import React, { Component } from "react";
import {
  Badge,
  Button,
  ButtonDropdown,
  Card,
  CardBody,
  Col,
  CustomInput,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import axios from "axios";
import createSocket from "../../../helpers/createSocket";
import moment from "moment";
import classNames from "classnames";
import { DateRangePicker } from "../../../components/common/DateRangePicker";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import { END_POINT } from "../../../constants/defaultValues";
import {
  AddCommaNumber,
  NotificatioErrController,
  NotificatioSucController,
} from "../../../helpers/Utils";
import { isD, isF, isR, isU } from "../../../helpers/Roles";
import LogsHelper from "../../../helpers/Logs";
import IntlMessages from "../../../helpers/IntlMessages";
import { getFeeOtherLabel as resolveFeeOtherLabel } from "../../../helpers/FeeOtherLabel";
import ProductImage from "../../../components/common/ProductImage";
import { Pagination } from "../../../containers/pages/general";
import { ComponentToPrintWrapper } from "../../../containers/pages/order";
import EInvoiceList from "./einvoice/EInvoiceList";
import {
  clickOnMobileMenu,
  setContainerClassnames,
  setSearchContext,
} from "../../../redux/actions";

const ROLE_ALIAS = "order";
const TODAY = moment().format("YYYY-MM-DD");
const ALL_ORDERS_DATE = "1900-01-01";
const ORDER_DATE_PRESETS = [
  { key: "today", label: "Hôm nay" },
  { key: "yesterday", label: "Hôm qua" },
  { key: "week", label: "Tuần này" },
  { key: "last_week", label: "Tuần trước" },
  { key: "all", label: "Tất cả" },
];

const STATUS_FILTERS = [
  { key: "all", label: "Tất cả", tone: "primary" },
  { key: "paid", label: "Đã thanh toán", tone: "success" },
  { key: "e_invoice_issued", label: "Đã xuất HĐĐT", tone: "info" },
  { key: "debt", label: "Công nợ", tone: "warning" },
  { key: "cancelled", label: "Đã hủy", tone: "danger" },
];

const SORT_OPTIONS = [
  { key: "newest", label: "Mới nhất" },
  { key: "oldest", label: "Cũ nhất" },
  { key: "total_desc", label: "Tổng tiền cao" },
  { key: "total_asc", label: "Tổng tiền thấp" },
];

const DETAIL_TABS = [
  { key: "info", label: "Thông tin" },
  { key: "products", label: "Sản phẩm" },
  { key: "payment", label: "Thanh toán" },
  { key: "einvoice", labelId: "invoice.tab.einvoice" },
  { key: "history", label: "Nhật ký" },
  { key: "preview", label: "Xem hóa đơn" },
];

const paymentMethodLabels = {
  cash: "Tiền mặt",
  transfer: "Chuyển khoản",
  card: "Thẻ",
  credit: "Công nợ",
  mixed: "Nhiều phương thức",
};

const paymentMethodEInvoiceLabels = {
  cash: "TM",
  transfer: "CK",
  card: "CK",
  credit: "CN",
  mixed: "TM/CK",
};

const E_INVOICE_STATUS_META = {
  none: { label: "Chưa xuất", color: "secondary" },
  draft: { label: "Nháp", color: "secondary" },
  processing: { label: "Đang xử lý", color: "info" },
  issued: { label: "Đã phát hành", color: "success" },
  signed: { label: "Đã ký", color: "success" },
  sent: { label: "Đã gửi", color: "success" },
  cancelled: { label: "Đã hủy", color: "danger" },
  error: { label: "Lỗi", color: "warning" },
};

const formatMoney = (value) => `${AddCommaNumber(Math.round(Number(value || 0)))} đ`;

const formatCompactMoney = (value) => {
  const num = Number(value || 0);
  if (num >= 1000000) {
    const rounded = num / 1000000;
    return `${rounded % 1 === 0 ? rounded : rounded.toFixed(1).replace(".", ",") } Tr`;
  }
  if (num >= 1000) {
    const rounded = num / 1000;
    return `${rounded % 1 === 0 ? rounded : rounded.toFixed(1).replace(".", ",") } K`;
  }
  return `${num} đ`;
};

const parseMoneyInput = (value) =>
  Number(String(value || "").replace(/\./g, "").replace(/,/g, "")) || 0;

const formatChange = (value) => {
  const number = Number(value || 0);
  const sign = number > 0 ? "+" : "";
  return `${sign}${number}%`;
};

const formatDateTime = (date, time) => {
  if (!date) return "--";
  return `${moment(date).format("DD/MM/YYYY")} - ${time || "--"}`;
};

const formatTimestamp = (value) => {
  if (!value) return "--";
  const date = moment(value);
  return date.isValid() ? date.format("DD/MM/YYYY HH:mm") : "--";
};

const getStatusClass = (statusKey) => {
  if (statusKey === "cancelled") return "danger";
  if (statusKey === "debt") return "warning";
  return "success";
};

const normalizePercentValue = (value) => {
  if (value === null || value === undefined || value === "") return "";
  return String(value).replace("%", "").trim();
};

const formatPercentTag = (value, suffix) => {
  const normalized = normalizePercentValue(value);
  if (!normalized || normalized === "100") return "";
  return `${normalized}% ${suffix}`;
};

const getVariantLabelParts = (value) => {
  if (!value) return [];
  return String(value)
    .split("|")
    .map((part) => part.trim())
    .filter(Boolean);
};

const getVariantLabel = (value) => {
  const raw = getVariantLabelParts(value)[0] || "";
  return raw.split(",")[0].trim();
};

const getVariantPrice = (value) => {
  const raw = getVariantLabelParts(value)[0] || "";
  const price = raw.split(",")[1];
  return price && !Number.isNaN(Number(price)) ? Number(price) : null;
};

const formatVariantMoney = (value) => `${AddCommaNumber(Math.round(Number(value || 0)))}đ`;

const getSizeVariantTag = (item = {}) => {
  let label = getVariantLabel(item.size);
  if (!label) return "";

  // Loại bỏ tiền tố "Size" nếu có sẵn trong nhãn để tránh lặp ("Size Size S" -> "Size S")
  label = label.replace(/^size\s*/i, "").trim();

  const price = getVariantPrice(item.size);
  return price ? `Size ${label} - ${formatVariantMoney(price)}` : `Size ${label}`;
};

const getVariantLabels = (value, prefixToStrip) =>
  getVariantLabelParts(value)
    .map((part) => {
      let label = part.split(",")[0].trim();
      if (prefixToStrip) {
        // Loại bỏ tiền tố trùng lặp (ví dụ "Vị Nguyên vị" -> "Nguyên vị")
        const regex = new RegExp(`^${prefixToStrip}\\s*`, "i");
        label = label.replace(regex, "");
      }
      return label.trim();
    })
    .filter(Boolean);

const getVariantTags = (item = {}) => {
  const tags = [];

  if (item.variant) {
    const parseVariantAttributes = (attributes) => {
      if (!attributes) return {};
      if (typeof attributes === "object") return attributes;
      try {
        return JSON.parse(attributes) || {};
      } catch {
        return {};
      }
    };

    const attrs = parseVariantAttributes(item.variant.attributes);
    ["size", "color", "material"].forEach((key) => {
      const attr = attrs[key];
      if (attr) {
        const val = typeof attr === "object" ? attr.label || attr.value : attr;
        const valStr = String(val || "").trim().toLowerCase();
        // Bỏ qua các nhãn placeholder mặc định của biến thể
        if (
          val &&
          valStr !== "no-size" &&
          valStr !== "no-color" &&
          valStr !== "no-material" &&
          valStr !== "no_size" &&
          valStr !== "no_color" &&
          valStr !== "no_material"
        ) {
          if (key === "size") {
            const cleanSize = String(val).replace(/^size\s*/i, "").trim();
            tags.push(`Size ${cleanSize}`);
          } else {
            tags.push(String(val).trim());
          }
        }
      }
    });

    if (tags.length === 0 && item.variant.sku) {
      tags.push(item.variant.sku);
    }
  } else {
    const size = getSizeVariantTag(item);
    if (size) tags.push(size);
    if (item.sugar) tags.push(formatPercentTag(item.sugar, "ngọt"));
    if (item.ice) tags.push(formatPercentTag(item.ice, "đá"));
    tags.push(...getVariantLabels(item.flavor, "Vị"));
    tags.push(...getVariantLabels(item.topping, "Topping"));
  }

  return tags.filter(Boolean);
};

class ContentComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      activeInvoice: null,
      selectedPins: [],
      summary: {
        total_bills: 0,
        revenue_amount: 0,
        debt_amount: 0,
        cancelled_bills: 0,
        changes: {},
        status_counts: {},
      },
      page: {
        pageSizes: [20, 50, 100],
        selectedPageSize: 20,
        currentPage: 1,
        totalPage: 1,
        totalItem: 0,
        search: "",
      },
      filters: {
        date_start: TODAY,
        date_end: TODAY,
        all: false,
        status: "all",
        sortBy: "newest",
      },
      is_loading_data: true,
      detailTab: "info",
      datePickerOpen: false,
      moreOpen: false,
      eInvoiceModalOpen: false,
      debtModalOpen: false,
      debtInvoice: null,
      debtAmount: "",
      debtCustomerId: "",
      debtCustomerName: "",
      debtCustomerPhone: "",
      debtCustomerAddress: "",
      debtSuggestions: [],
      isLoadingDebtCustomer: false,
      isSubmittingDebt: false,
      repayModalOpen: false,
      repayInvoice: null,
      repayAmount: "",
      repayPaymentMethod: "cash",
      repayScope: "invoice",
      isSubmittingRepay: false,
      eInvoiceConfig: null,
      eInvoiceProviders: [],
      eInvoiceAdjustments: [],
      eInvoiceAdjustmentsForId: null,
      isLoadingEInvoiceAdjustments: false,
      eInvoiceIssueModalOpen: false,
      eInvoiceMode: "create",
      eInvoiceInvoice: null,
      eInvoiceCustomerName: "",
      eInvoiceCustomerTaxId: "",
      eInvoiceCustomerAddress: "",
      eInvoiceCustomerEmail: "",
      eInvoiceCustomerPhone: "",
      eInvoiceVatRate: 10,
      eInvoicePaymentMethod: "TM/CK",
      eInvoiceNote: "",
      eInvoiceIssueOfficial: true,
      isSubmittingEInvoice: false,
      eInvoiceAdjustmentModalOpen: false,
      eInvoiceAdjustmentMode: "einvoice",
      eInvoiceAdjustmentInvoice: null,
      eInvoiceAdjustmentItems: [],
      eInvoiceAdjustmentDiscount: "",
      eInvoiceAdjustmentTaxFee: "",
      eInvoiceAdjustmentFeeOther: "",
      eInvoiceAdjustmentVatRate: 10,
      eInvoiceAdjustmentReason: "",
      eInvoiceAdjustmentIssueOfficial: false,
      eInvoiceAdjustmentPreview: null,
      eInvoiceAdjustmentProducts: [],
      eInvoiceAdjustmentProductSearch: "",
      eInvoiceAdjustmentSelectedProductKey: "",
      isLoadingEInvoiceAdjustmentProducts: false,
      isPreviewingEInvoiceAdjustment: false,
      isSubmittingEInvoiceAdjustment: false,
      isDetailModalOpen: false,
    };

    this.socket = createSocket();
    this.eInvoiceAdjustmentPreviewTimer = null;
    this.eInvoiceAdjustmentProductSearchTimer = null;
    this.debtCustomerSearchTimer = null;
    this.debtCustomerSearchRequestId = 0;
  }

  componentDidMount() {
    this.props.setSearchContext("order");
    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });
    this.socket.on("refresh-done-order", this.handleOrderRefresh);
    this.socket.on("refresh-recent-order", this.handleOrderRefresh);
    this.fetchEInvoiceConfig();
    this.fetchEInvoiceProviders();
    this.dataListRender();
  }

  componentWillUnmount() {
    this.socket.off("refresh-done-order", this.handleOrderRefresh);
    this.socket.off("refresh-recent-order", this.handleOrderRefresh);
    this.socket.close();
    if (this.eInvoiceAdjustmentPreviewTimer) {
      window.clearTimeout(this.eInvoiceAdjustmentPreviewTimer);
    }
    if (this.eInvoiceAdjustmentProductSearchTimer) {
      window.clearTimeout(this.eInvoiceAdjustmentProductSearchTimer);
    }
    if (this.debtCustomerSearchTimer) {
      window.clearTimeout(this.debtCustomerSearchTimer);
    }
  }

  handleOrderRefresh = () => {
    this.dataListRender();
  };

  getEInvoiceUserId = () =>
    localStorage.getItem("user_id") || localStorage.getItem("b") || "";

  fetchEInvoiceConfig = () => {
    const userId = this.getEInvoiceUserId();
    const tokenStr = localStorage.getItem("access_token");

    if (!userId) return;

    axios
      .get(`${END_POINT}/api/einvoice/config?user_id=${userId}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        this.setState({ eInvoiceConfig: res.data?.data || null });
      })
      .catch(() => {
        this.setState({ eInvoiceConfig: null });
      });
  };

  fetchEInvoiceProviders = () => {
    const tokenStr = localStorage.getItem("access_token");

    axios
      .get(`${END_POINT}/api/einvoice/providers`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        this.setState({ eInvoiceProviders: res.data?.data || [] });
      })
      .catch(() => {
        this.setState({ eInvoiceProviders: [] });
      });
  };

  isEInvoiceEnabled = () => {
    const { eInvoiceConfig } = this.state;
    return !!(eInvoiceConfig && eInvoiceConfig.is_active);
  };

  getDefaultEInvoiceVatRate = () => {
    const vatRate = this.state.eInvoiceConfig?.vat_rate;
    return vatRate !== undefined && vatRate !== null ? vatRate : 10;
  };

  getCurrentEInvoiceProvider = () => {
    const { eInvoiceConfig, eInvoiceProviders } = this.state;
    return (
      eInvoiceProviders.find((item) => item.name === eInvoiceConfig?.provider) ||
      null
    );
  };

  supportsEInvoiceAdjustment = () => {
    const provider = this.getCurrentEInvoiceProvider();
    return !!provider?.supportsAdjustmentInvoice;
  };

  getEInvoiceProviderLabel = (providerName) => {
    const provider = this.state.eInvoiceProviders.find(
      (item) => item.name === providerName,
    );
    return provider?.label || providerName || "--";
  };

  fetchEInvoiceAdjustments = (invoice, force = false) => {
    const eInvoiceId = invoice?.e_invoice?.id;

    if (!eInvoiceId) {
      this.setState({
        eInvoiceAdjustments: [],
        eInvoiceAdjustmentsForId: null,
        isLoadingEInvoiceAdjustments: false,
      });
      return;
    }

    if (!force && this.state.eInvoiceAdjustmentsForId === eInvoiceId) return;

    const tokenStr = localStorage.getItem("access_token");
    const userId = this.getEInvoiceUserId();

    this.setState({
      eInvoiceAdjustmentsForId: eInvoiceId,
      isLoadingEInvoiceAdjustments: true,
    });

    axios
      .get(
        `${END_POINT}/api/einvoice/${eInvoiceId}/adjustments?user_id=${userId}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        this.setState((prev) => {
          if (prev.eInvoiceAdjustmentsForId !== eInvoiceId) return null;
          return {
            eInvoiceAdjustments: res.data?.data || [],
            isLoadingEInvoiceAdjustments: false,
          };
        });
      })
      .catch(() => {
        this.setState((prev) => {
          if (prev.eInvoiceAdjustmentsForId !== eInvoiceId) return null;
          return {
            eInvoiceAdjustments: [],
            isLoadingEInvoiceAdjustments: false,
          };
        });
      });
  };

  setDetailTab = (detailTab, invoice) => {
    this.setState({ detailTab }, () => {
      if (detailTab === "einvoice") {
        this.fetchEInvoiceAdjustments(invoice);
      }
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.searchKeyword !== this.props.searchKeyword) {
      this.setState(
        (prev) => ({
          page: {
            ...prev.page,
            currentPage: 1,
            search: this.props.searchKeyword || "",
          },
        }),
        this.dataListRender,
      );
    }
  }

  buildQueryString = () => {
    const { page, filters } = this.state;
    const params = {
      pageSize: page.selectedPageSize,
      currentPage: page.currentPage,
      search: page.search || "",
      date_start: filters.date_start,
      date_end: filters.date_end,
      all: filters.all,
      status: filters.status,
      sortBy: filters.sortBy,
      sortDir:
        filters.sortBy === "oldest" || filters.sortBy === "total_asc"
          ? "asc"
          : "desc",
    };

    return Object.keys(params)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join("&");
  };

  dataListRender = () => {
    const tokenStr = localStorage.getItem("access_token");
    this.setState({ is_loading_data: true });

    axios
      .get(`${END_POINT}/bill/invoice-dashboard?${this.buildQueryString()}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        const items = data.data || [];
        const currentActivePin = this.state.activeInvoice?.pin;
        const nextActive =
          items.find((item) => item.pin === currentActivePin) || items[0] || null;

        this.setState((prev) => ({
          items,
          activeInvoice: nextActive,
          summary: data.summary || prev.summary,
          is_loading_data: false,
          selectedPins: prev.selectedPins.filter((pin) =>
            items.some((item) => item.pin === pin),
          ),
          page: {
            ...prev.page,
            currentPage: data.page?.currentPage || 1,
            totalPage: data.page?.totalPage || 1,
            totalItem: data.page?.totalItem || 0,
          },
        }), () => {
          if (this.state.detailTab === "einvoice") {
            this.fetchEInvoiceAdjustments(this.state.activeInvoice, true);
          }
        });
      })
      .catch((err) => {
        this.setState({ is_loading_data: false });
        NotificatioErrController(
          err.response?.data?.responseText || "Có lỗi xảy ra khi tải hóa đơn.",
        );
      });
  };

  setFilters = (filters) => {
    this.setState(
      (prev) => ({
        filters: {
          ...prev.filters,
          ...filters,
        },
        detailTab: "info",
        page: {
          ...prev.page,
          currentPage: 1,
        },
      }),
      this.dataListRender,
    );
  };

  getDatePresetRange = (preset) => {
    if (preset === "today") {
      return { date_start: TODAY, date_end: TODAY };
    }

    if (preset === "yesterday") {
      const yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
      return { date_start: yesterday, date_end: yesterday };
    }

    if (preset === "week") {
      return {
        date_start: moment().startOf("isoWeek").format("YYYY-MM-DD"),
        date_end: moment().endOf("isoWeek").format("YYYY-MM-DD"),
      };
    }

    if (preset === "last_week") {
      return {
        date_start: moment().subtract(1, "week").startOf("isoWeek").format("YYYY-MM-DD"),
        date_end: moment().subtract(1, "week").endOf("isoWeek").format("YYYY-MM-DD"),
      };
    }

    if (preset === "month") {
      return {
        date_start: moment().startOf("month").format("YYYY-MM-DD"),
        date_end: moment().endOf("month").format("YYYY-MM-DD"),
      };
    }

    if (preset === "last_month") {
      return {
        date_start: moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
        date_end: moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
      };
    }

    return null;
  };

  isDatePresetActive = (preset) => {
    const { filters } = this.state;

    if (preset === "all") {
      return filters.all;
    }

    const range = this.getDatePresetRange(preset);
    return (
      !filters.all &&
      range &&
      filters.date_start === range.date_start &&
      filters.date_end === range.date_end
    );
  };

  setDatePreset = (preset) => {
    if (preset === "all") {
      this.setFilters({ all: true });
      return;
    }

    const range = this.getDatePresetRange(preset);
    if (range) {
      this.setFilters({ ...range, all: false });
    }
  };

  onDateRangeChange = (range, interaction = {}) => {
    if (interaction.source === "start") {
      return;
    }

    const dateStart = moment(range.startDate).format("YYYY-MM-DD");
    const dateEnd = moment(range.endDate).format("YYYY-MM-DD");

    this.setState({ datePickerOpen: false }, () => {
      if (dateStart === ALL_ORDERS_DATE && dateEnd === ALL_ORDERS_DATE) {
        this.setDatePreset("all");
        return;
      }

      this.setFilters({
        date_start: dateStart,
        date_end: dateEnd,
        all: false,
      });
    });
  };

  onChangePage = (page) => {
    this.setState(
      (prev) => ({
        page: {
          ...prev.page,
          currentPage: page,
        },
      }),
      this.dataListRender,
    );
  };

  onChangePageSize = (e) => {
    const selectedPageSize = Number(e.target.value) || 20;
    this.setState(
      (prev) => ({
        page: {
          ...prev.page,
          selectedPageSize,
          currentPage: 1,
        },
      }),
      this.dataListRender,
    );
  };

  onSelectInvoice = (invoice) => {
    const isMobileTablet = window.innerWidth < 992;
    this.setState({
      activeInvoice: invoice,
      detailTab: "info",
      isDetailModalOpen: isMobileTablet,
      eInvoiceAdjustments: [],
      eInvoiceAdjustmentsForId: null,
      isLoadingEInvoiceAdjustments: false,
    });
  };

  closeDetailModal = () => {
    this.setState({ isDetailModalOpen: false });
  };

  onTogglePin = (pin, e) => {
    if (e) e.stopPropagation();
    this.setState((prev) => ({
      selectedPins: prev.selectedPins.includes(pin)
        ? prev.selectedPins.filter((item) => item !== pin)
        : [...prev.selectedPins, pin],
    }));
  };

  getCustomerDebt = (invoice) =>
    Math.max(
      Number(invoice?.customer?.total_debt || 0),
      Number(invoice?.totals?.debt || 0),
    );

  getRepayDebtAmount = (invoice, scope = this.state.repayScope) => {
    if (scope === "customer") return this.getCustomerDebt(invoice);
    return Number(invoice?.totals?.debt || 0);
  };

  getEInvoiceMeta = (invoice) => {
    const status = invoice?.e_invoice?.status || "none";
    return E_INVOICE_STATUS_META[status] || {
      label: status || "Chưa xuất",
      color: "secondary",
    };
  };

  getDefaultEInvoiceIssueOfficial = () => {
    const { eInvoiceConfig } = this.state;
    if (!eInvoiceConfig) return true;
    return !!eInvoiceConfig.auto_issue || eInvoiceConfig.create_draft_when_not_issue === false;
  };

  getEInvoicePaymentMethod = (invoice) => {
    return paymentMethodEInvoiceLabels[invoice?.payment_method] || "TM/CK";
  };

  buildEInvoiceItems = (invoice) => {
    return (invoice?.products || []).map((item, index) => ({
      line_number: index + 1,
      line_type: 1,
      item_code: `SP${String(index + 1).padStart(3, "0")}`,
      product_id: item.product_id || null,
      product_variant_id: item.product_variant_id || null,
      order_ids: item.order_ids || item.ids || [],
      item_name: item.name || "Sản phẩm",
      unit: item.sale_unit || "cái",
      quantity: item.count || 1,
      unit_price: item.unit_price || 0,
      size: item.size || "",
      ice: item.ice || "",
      sugar: item.sugar || "",
      flavor: item.flavor || "",
      topping: item.topping || "",
      note: item.note || "",
    }));
  };

  buildEInvoicePayload = () => {
    const {
      eInvoiceInvoice,
      eInvoiceCustomerName,
      eInvoiceCustomerTaxId,
      eInvoiceCustomerAddress,
      eInvoiceCustomerEmail,
      eInvoiceCustomerPhone,
      eInvoiceVatRate,
      eInvoicePaymentMethod,
      eInvoiceNote,
      eInvoiceIssueOfficial,
    } = this.state;

    const subtotal = Number(eInvoiceInvoice?.totals?.subtotal || 0);
    const discountAmount = Number(eInvoiceInvoice?.totals?.discount || 0);
    const taxFeeAmount = Number(eInvoiceInvoice?.totals?.tax_fee || 0);
    const feeOtherAmount = Number(eInvoiceInvoice?.totals?.fee_other || 0);

    return {
      user_id: this.getEInvoiceUserId(),
      bill_id: eInvoiceInvoice?.bill_id,
      customer_name: eInvoiceCustomerName || "Bán cho người tiêu dùng",
      customer_tax_id: eInvoiceCustomerTaxId || "",
      customer_address: eInvoiceCustomerAddress || "",
      customer_email: eInvoiceCustomerEmail || "",
      customer_phone: eInvoiceCustomerPhone || "",
      subtotal,
      discount_amount: discountAmount,
      tax_fee_amount: taxFeeAmount,
      fee_other_amount: feeOtherAmount,
      vat_rate: Number(eInvoiceVatRate || 0),
      payment_method: eInvoicePaymentMethod || "TM/CK",
      items: this.buildEInvoiceItems(eInvoiceInvoice),
      note: eInvoiceNote || `Đơn hàng ${eInvoiceInvoice?.code || eInvoiceInvoice?.bill_id || ""}`,
      invoice_date: eInvoiceInvoice?.date || moment().format("YYYY-MM-DD"),
      is_draft: !eInvoiceIssueOfficial,
    };
  };

  onDeleteBill = (pin) => {
    if (!isD(ROLE_ALIAS)) return false;

    const tokenStr = localStorage.getItem("access_token");
    axios
      .delete(`${END_POINT}/order`, {
        data: {
          arrayPin: [pin],
        },
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then(() => {
        NotificatioSucController(
          this.props.intl.formatMessage({ id: "action.success" }),
        );
        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["bill-delete"],
        });
        this.dataListRender();
      })
      .catch((err) => {
        NotificatioErrController(
          err.response?.data?.responseText || "Có lỗi xảy ra khi hủy hóa đơn.",
        );
      });
  };

  onRestoreBill = (pin) => {
    if (!isD(ROLE_ALIAS)) return false;

    const tokenStr = localStorage.getItem("access_token");
    axios
      .put(
        `${END_POINT}/order/restore-order`,
        { arrayPin: [pin] },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then(() => {
        NotificatioSucController(
          this.props.intl.formatMessage({ id: "invoice.success.restore" }),
        );
        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["bill-restore"],
        });
        this.dataListRender();
      })
      .catch((err) => {
        NotificatioErrController(
          err.response?.data?.responseText || "Có lỗi xảy ra khi khôi phục.",
        );
      });
  };

  onDestroyBill = (pin) => {
    const text = this.props.intl.formatMessage({ id: "invoice.confirm.destroy" });
    if (!window.confirm(text)) return false;
    if (!isD(ROLE_ALIAS)) return false;

    const tokenStr = localStorage.getItem("access_token");
    axios
      .delete(`${END_POINT}/order/destroy-order`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
        data: {
          arrayPin: [pin],
        },
      })
      .then((res) => {
        NotificatioSucController(res.data.responseText);
        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["bill-destroy"],
        });
        this.dataListRender();
      })
      .catch((err) => {
        NotificatioErrController(
          err.response?.data?.responseText || "Có lỗi xảy ra khi xóa hóa đơn.",
        );
      });
  };

  canManageOrderDebt = () => isU(ROLE_ALIAS) || isF(ROLE_ALIAS);

  canViewOrderDashboard = () =>
    isR(ROLE_ALIAS) || this.canManageOrderDebt();

  openDebtModal = (invoice) => {
    if (!this.canManageOrderDebt() || !invoice || invoice.is_cancelled || invoice.has_debt) {
      return;
    }

    const invoiceTotal = Number(invoice.totals?.total || 0);
    if (invoiceTotal <= 0) return;

    this.setState({
      debtModalOpen: true,
      debtInvoice: invoice,
      debtAmount: AddCommaNumber(Math.round(invoiceTotal)),
      debtCustomerId: "",
      debtCustomerName: invoice.customer?.name || "",
      debtCustomerPhone: invoice.customer?.phone || "",
      debtCustomerAddress: invoice.customer?.address || "",
      debtSuggestions: [],
      isLoadingDebtCustomer: false,
    });
  };

  closeDebtModal = () => {
    if (this.state.isSubmittingDebt) return;

    this.debtCustomerSearchRequestId += 1;
    if (this.debtCustomerSearchTimer) {
      window.clearTimeout(this.debtCustomerSearchTimer);
      this.debtCustomerSearchTimer = null;
    }
    this.setState({
      debtModalOpen: false,
      debtInvoice: null,
      debtAmount: "",
      debtCustomerId: "",
      debtCustomerName: "",
      debtCustomerPhone: "",
      debtCustomerAddress: "",
      debtSuggestions: [],
      isLoadingDebtCustomer: false,
    });
  };

  onChangeDebtAmount = (event) => {
    const amount = parseMoneyInput(event.target.value);
    this.setState({ debtAmount: amount ? AddCommaNumber(amount) : "" });
  };

  onChangeDebtCustomerField = (field, event) => {
    const value = event.target.value;
    this.setState({ debtCustomerId: "", [field]: value });
    if (field === "debtCustomerPhone") {
      this.searchDebtCustomers(value);
    }
  };

  searchDebtCustomers = (keyword) => {
    if (this.debtCustomerSearchTimer) {
      window.clearTimeout(this.debtCustomerSearchTimer);
    }
    const normalizedKeyword = String(keyword || "").trim();
    if (!normalizedKeyword) {
      this.debtCustomerSearchRequestId += 1;
      this.setState({ debtSuggestions: [], isLoadingDebtCustomer: false });
      return;
    }

    this.debtCustomerSearchTimer = window.setTimeout(() => {
      const requestId = this.debtCustomerSearchRequestId + 1;
      this.debtCustomerSearchRequestId = requestId;
      const tokenStr = localStorage.getItem("access_token");
      this.setState({ isLoadingDebtCustomer: true });
      axios
        .get(`${END_POINT}/customer/search?keyword=${encodeURIComponent(normalizedKeyword)}`, {
          headers: { Authorization: `Bearer ${tokenStr}` },
        })
        .then((res) => {
          if (requestId !== this.debtCustomerSearchRequestId) return;
          this.setState({
            debtSuggestions:
              res.data?.status === 200 && Array.isArray(res.data?.data)
                ? res.data.data
                : [],
          });
        })
        .catch(() => {
          if (requestId === this.debtCustomerSearchRequestId) {
            this.setState({ debtSuggestions: [] });
          }
        })
        .finally(() => {
          if (requestId === this.debtCustomerSearchRequestId) {
            this.setState({ isLoadingDebtCustomer: false });
          }
        });
    }, 300);
  };

  selectDebtCustomer = (customer) => {
    this.debtCustomerSearchRequestId += 1;
    this.setState({
      debtCustomerId: customer.id || "",
      debtCustomerName: customer.name || "",
      debtCustomerPhone: customer.phone || "",
      debtCustomerAddress: customer.address || "",
      debtSuggestions: [],
      isLoadingDebtCustomer: false,
    });
  };

  submitDebt = () => {
    const {
      debtInvoice,
      debtAmount,
      debtCustomerId,
      debtCustomerName,
      debtCustomerPhone,
      debtCustomerAddress,
    } = this.state;
    const amount = parseMoneyInput(debtAmount);
    const invoiceTotal = Number(debtInvoice?.totals?.total || 0);

    if (!this.canManageOrderDebt() || !debtInvoice) return;
    if (!debtCustomerName.trim() && !debtCustomerPhone.trim()) {
      NotificatioErrController("Vui lòng nhập tên hoặc số điện thoại khách hàng.");
      return;
    }
    if (amount <= 0 || amount > invoiceTotal) {
      NotificatioErrController("Số tiền nợ phải lớn hơn 0 và không vượt quá tổng hóa đơn.");
      return;
    }

    this.setState({ isSubmittingDebt: true });
    const tokenStr = localStorage.getItem("access_token");
    axios
      .put(
        `${END_POINT}/order/convert-to-debt`,
        {
          orders_id: debtInvoice.orders_id || [],
          debt_amount: amount,
          customer_id: debtCustomerId || undefined,
          name: debtCustomerName,
          phone: debtCustomerPhone,
          address: debtCustomerAddress,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        NotificatioSucController(res.data?.responseText || "Ghi nhận công nợ thành công");
        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["customer-debt-update"] || "Ghi nhận công nợ",
        });
        this.socket.emit("refresh-done-order", {
          user_id: localStorage.getItem("user_id"),
        });
        this.setState(
          {
            debtModalOpen: false,
            debtInvoice: null,
            debtAmount: "",
            debtCustomerId: "",
            debtCustomerName: "",
            debtCustomerPhone: "",
            debtCustomerAddress: "",
            debtSuggestions: [],
            isLoadingDebtCustomer: false,
            isSubmittingDebt: false,
          },
          this.dataListRender,
        );
      })
      .catch((error) => {
        this.setState({ isSubmittingDebt: false });
        NotificatioErrController(
          error.response?.data?.responseText || "Có lỗi xảy ra khi ghi nhận công nợ.",
        );
      });
  };

  openRepayModal = (invoice) => {
    if (invoice?.is_cancelled) return;

    const defaultScope = invoice?.has_debt ? "invoice" : "customer";
    const debtAmount = this.getRepayDebtAmount(invoice, defaultScope);
    if (debtAmount <= 0) return;

    this.setState({
      repayModalOpen: true,
      repayInvoice: invoice,
      repayAmount: AddCommaNumber(Math.round(debtAmount)),
      repayPaymentMethod: "cash",
      repayScope: defaultScope,
    });
  };

  closeRepayModal = () => {
    if (this.state.isSubmittingRepay) return;

    this.setState({
      repayModalOpen: false,
      repayInvoice: null,
      repayAmount: "",
      repayPaymentMethod: "cash",
      repayScope: "invoice",
    });
  };

  onChangeRepayAmount = (e) => {
    const value = parseMoneyInput(e.target.value);
    this.setState({
      repayAmount: value ? AddCommaNumber(value) : "",
    });
  };

  onChangeRepayScope = (e) => {
    const repayScope = e.target.value;
    const debtAmount = this.getRepayDebtAmount(this.state.repayInvoice, repayScope);

    this.setState({
      repayScope,
      repayAmount: debtAmount ? AddCommaNumber(Math.round(debtAmount)) : "",
    });
  };

  submitRepayDebt = () => {
    const { repayInvoice, repayAmount, repayPaymentMethod, repayScope } = this.state;
    const amount = parseMoneyInput(repayAmount);
    const maxDebt = this.getRepayDebtAmount(repayInvoice, repayScope);

    if (!repayInvoice) return;

    if (amount <= 0) {
      NotificatioErrController("Vui lòng nhập số tiền trả nợ hợp lệ.");
      return;
    }

    if (amount > maxDebt) {
      NotificatioErrController("Số tiền trả nợ không được vượt quá công nợ còn lại.");
      return;
    }

    const tokenStr = localStorage.getItem("access_token");
    this.setState({ isSubmittingRepay: true });

    axios
      .put(
        `${END_POINT}/order/repay-debt`,
        {
          orders_id: repayInvoice.orders_id || [],
          amount,
          payment_method: repayPaymentMethod,
          scope: repayScope,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        NotificatioSucController(res.data.responseText || "Trả nợ hóa đơn thành công");
        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["customer-debt-update"] || "Trả nợ hóa đơn",
        });
        this.setState(
          {
            repayModalOpen: false,
            repayInvoice: null,
            repayAmount: "",
            repayPaymentMethod: "cash",
            repayScope: "invoice",
            isSubmittingRepay: false,
          },
          this.dataListRender,
        );
      })
      .catch((err) => {
        this.setState({ isSubmittingRepay: false });
        NotificatioErrController(
          err.response?.data?.responseText || "Có lỗi xảy ra khi trả nợ hóa đơn.",
        );
      });
  };

  openEInvoiceIssueModal = (invoice, mode = "create") => {
    if (!invoice || invoice.is_cancelled) return;

    const existing = invoice.e_invoice || {};
    const isEdit = mode === "edit" && existing.id;
    const defaultIssueOfficial = isEdit ? false : this.getDefaultEInvoiceIssueOfficial();

    this.setState({
      eInvoiceIssueModalOpen: true,
      eInvoiceMode: isEdit ? "edit" : "create",
      eInvoiceInvoice: invoice,
      eInvoiceCustomerName:
        existing.customer_name || invoice.customer?.name || "Bán cho người tiêu dùng",
      eInvoiceCustomerTaxId: existing.customer_tax_id || "",
      eInvoiceCustomerAddress:
        existing.customer_address || invoice.customer?.address || "",
      eInvoiceCustomerEmail: existing.customer_email || "",
      eInvoiceCustomerPhone:
        existing.customer_phone || invoice.customer?.phone || "",
      eInvoiceVatRate:
        existing.vat_rate !== undefined && existing.vat_rate !== null
          ? existing.vat_rate
          : this.getDefaultEInvoiceVatRate(),
      eInvoicePaymentMethod:
        existing.payment_method || this.getEInvoicePaymentMethod(invoice),
      eInvoiceNote:
        existing.note || `Đơn hàng ${invoice.code || invoice.bill_id || ""}`,
      eInvoiceIssueOfficial: defaultIssueOfficial,
    });
  };

  closeEInvoiceIssueModal = () => {
    if (this.state.isSubmittingEInvoice) return;

    this.setState({
      eInvoiceIssueModalOpen: false,
      eInvoiceMode: "create",
      eInvoiceInvoice: null,
      eInvoiceCustomerName: "",
      eInvoiceCustomerTaxId: "",
      eInvoiceCustomerAddress: "",
      eInvoiceCustomerEmail: "",
      eInvoiceCustomerPhone: "",
      eInvoiceVatRate: this.getDefaultEInvoiceVatRate(),
      eInvoicePaymentMethod: "TM/CK",
      eInvoiceNote: "",
      eInvoiceIssueOfficial: true,
    });
  };

  submitEInvoice = () => {
    const { eInvoiceMode, eInvoiceInvoice, eInvoiceIssueOfficial } = this.state;
    const existingId = eInvoiceInvoice?.e_invoice?.id;
    const payload = this.buildEInvoicePayload();
    const tokenStr = localStorage.getItem("access_token");

    if (!payload.user_id) {
      NotificatioErrController("Không tìm thấy thông tin người dùng.");
      return;
    }

    if (!payload.bill_id) {
      NotificatioErrController("Không tìm thấy mã hóa đơn để xuất HĐĐT.");
      return;
    }

    if (!payload.customer_name) {
      NotificatioErrController("Vui lòng nhập tên người mua.");
      return;
    }

    this.setState({ isSubmittingEInvoice: true });

    const request =
      eInvoiceMode === "edit" && existingId
        ? axios
            .put(
              `${END_POINT}/api/einvoice/${existingId}`,
              payload,
              { headers: { Authorization: `Bearer ${tokenStr}` } },
            )
            .then((res) => {
              if (!eInvoiceIssueOfficial) return res;
              return axios.post(
                `${END_POINT}/api/einvoice/${existingId}/issue-official`,
                { user_id: payload.user_id },
                { headers: { Authorization: `Bearer ${tokenStr}` } },
              );
            })
        : axios.post(`${END_POINT}/api/einvoice/issue`, payload, {
            headers: { Authorization: `Bearer ${tokenStr}` },
          });

    request
      .then((res) => {
        NotificatioSucController(
          res.data?.message ||
            (eInvoiceIssueOfficial
              ? "Đã phát hành hóa đơn điện tử"
              : "Đã lưu hóa đơn điện tử"),
        );
        this.setState(
          {
            eInvoiceIssueModalOpen: false,
            eInvoiceMode: "create",
            eInvoiceInvoice: null,
            isSubmittingEInvoice: false,
          },
          this.dataListRender,
        );
      })
      .catch((err) => {
        this.setState({ isSubmittingEInvoice: false });
        NotificatioErrController(
          err.response?.data?.responseText || "Có lỗi xảy ra khi xuất hóa đơn điện tử.",
        );
        if (err.response?.status === 409) this.dataListRender();
      });
  };

  buildEInvoiceAdjustmentItems = (invoice) =>
    this.buildEInvoiceItems(invoice).map((item) => ({
      ...item,
      source_quantity: item.quantity,
      source_unit_price: item.unit_price,
    }));

  parseVariantAttributes = (attributes) => {
    if (!attributes) return {};
    if (typeof attributes === "object") return attributes;
    try {
      return JSON.parse(attributes);
    } catch (error) {
      return {};
    }
  };

  formatVariantLabel = (variant) => {
    const attributes = this.parseVariantAttributes(variant?.attributes);
    const attributeLabel = Object.values(attributes)
      .filter((value) => value !== undefined && value !== null && value !== "")
      .join(" / ");
    return attributeLabel || variant?.sku || `Biến thể #${variant?.id}`;
  };

  getProductVariants = (product) =>
    product?.variants || product?.variant || product?.ProductVariants || [];

  getProductDisplayPrice = (product, variant) => {
    if (variant) {
      return Number(variant.price || 0);
    }
    if (product?.active_sale && Number(product?.price_sale || 0) > 0) {
      return Number(product.price_sale || 0);
    }
    return Number(product?.price || 0);
  };

  getEInvoiceAdjustmentProductRows = (products = this.state.eInvoiceAdjustmentProducts) => {
    const rows = [];
    products.forEach((product) => {
      const variants = this.getProductVariants(product);
      if (variants.length) {
        variants.forEach((variant) => {
          rows.push({
            key: `${product.id}:${variant.id}`,
            product,
            variant,
            label: `${product.name} - ${this.formatVariantLabel(variant)}`,
          });
        });
      } else {
        rows.push({
          key: `${product.id}:`,
          product,
          variant: null,
          label: product.name,
        });
      }
    });
    return rows;
  };

  fetchEInvoiceAdjustmentProducts = (
    search = this.state.eInvoiceAdjustmentProductSearch,
  ) => {
    const tokenStr = localStorage.getItem("access_token");
    this.setState({ isLoadingEInvoiceAdjustmentProducts: true });

    axios
      .get(
        `${END_POINT}/product/json?pageSize=30&currentPage=1&search=${encodeURIComponent(
          search || "",
        )}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        const products = res.data?.data || [];
        const rows = this.getEInvoiceAdjustmentProductRows(products);
        this.setState((prev) => ({
          eInvoiceAdjustmentProducts: products,
          eInvoiceAdjustmentSelectedProductKey: rows.some(
            (row) => row.key === prev.eInvoiceAdjustmentSelectedProductKey,
          )
            ? prev.eInvoiceAdjustmentSelectedProductKey
            : rows[0]?.key || "",
          isLoadingEInvoiceAdjustmentProducts: false,
        }));
      })
      .catch(() => {
        this.setState({
          eInvoiceAdjustmentProducts: [],
          eInvoiceAdjustmentSelectedProductKey: "",
          isLoadingEInvoiceAdjustmentProducts: false,
        });
      });
  };

  scheduleEInvoiceAdjustmentProductSearch = (value) => {
    this.setState({ eInvoiceAdjustmentProductSearch: value });
    if (this.eInvoiceAdjustmentProductSearchTimer) {
      window.clearTimeout(this.eInvoiceAdjustmentProductSearchTimer);
    }
    this.eInvoiceAdjustmentProductSearchTimer = window.setTimeout(() => {
      this.fetchEInvoiceAdjustmentProducts(value);
    }, 350);
  };

  buildEInvoiceAdjustmentProductItem = (product, variant) => {
    const unitPrice = this.getProductDisplayPrice(product, variant);
    const attributes = this.parseVariantAttributes(variant?.attributes);
    return {
      line_number: this.state.eInvoiceAdjustmentItems.length + 1,
      line_type: 1,
      item_code: variant?.sku || product.sku || `SP${product.id}`,
      product_id: product.id,
      product_variant_id: variant?.id || null,
      order_ids: [],
      item_name: product.name || "Sản phẩm",
      unit: product.sale_unit || "cái",
      quantity: 1,
      unit_price: unitPrice,
      source_quantity: 0,
      source_unit_price: 0,
      size: attributes.size || attributes.Size || "",
      ice: "",
      sugar: "",
      flavor: attributes.flavor || attributes.Flavor || "",
      topping: attributes.topping || attributes.Topping || "",
      note: "",
    };
  };

  addEInvoiceAdjustmentProduct = () => {
    const rows = this.getEInvoiceAdjustmentProductRows();
    const selected = rows.find(
      (row) => row.key === this.state.eInvoiceAdjustmentSelectedProductKey,
    );
    if (!selected) {
      NotificatioErrController("Vui lòng chọn sản phẩm cần thêm.");
      return;
    }

    const newItem = this.buildEInvoiceAdjustmentProductItem(
      selected.product,
      selected.variant,
    );
    this.setState((prev) => {
      const existingIndex = prev.eInvoiceAdjustmentItems.findIndex(
        (item) =>
          Number(item.product_id) === Number(newItem.product_id) &&
          Number(item.product_variant_id || 0) ===
            Number(newItem.product_variant_id || 0),
      );

      if (existingIndex >= 0) {
        return {
          eInvoiceAdjustmentItems: prev.eInvoiceAdjustmentItems.map((item, index) =>
            index === existingIndex
              ? { ...item, quantity: Number(item.quantity || 0) + 1 }
              : item,
          ),
        };
      }

      return {
        eInvoiceAdjustmentItems: [...prev.eInvoiceAdjustmentItems, newItem],
      };
    }, this.scheduleEInvoiceAdjustmentPreview);
  };

  removeEInvoiceAdjustmentItem = (index) => {
    this.setState((prev) => {
      const item = prev.eInvoiceAdjustmentItems[index];
      const isNewItem =
        Number(item?.source_quantity || 0) === 0 &&
        (!Array.isArray(item?.order_ids) || item.order_ids.length === 0);

      return {
        eInvoiceAdjustmentItems: isNewItem
          ? prev.eInvoiceAdjustmentItems.filter((_, itemIndex) => itemIndex !== index)
          : prev.eInvoiceAdjustmentItems.map((row, itemIndex) =>
              itemIndex === index ? { ...row, quantity: 0 } : row,
            ),
      };
    }, this.scheduleEInvoiceAdjustmentPreview);
  };

  buildEInvoiceAdjustmentPayload = (issueOfficial = this.state.eInvoiceAdjustmentIssueOfficial) => {
    const {
      eInvoiceAdjustmentItems,
      eInvoiceAdjustmentDiscount,
      eInvoiceAdjustmentTaxFee,
      eInvoiceAdjustmentFeeOther,
      eInvoiceAdjustmentVatRate,
      eInvoiceAdjustmentReason,
    } = this.state;

    const items = eInvoiceAdjustmentItems.map((item, index) => ({
      ...item,
      line_number: index + 1,
      quantity: Number(item.quantity || 0),
      unit_price: Number(item.unit_price || 0),
    }));
    const subtotal = items.reduce(
      (sum, item) => sum + Number(item.quantity || 0) * Number(item.unit_price || 0),
      0,
    );

    return {
      user_id: this.getEInvoiceUserId(),
      items,
      subtotal,
      discount_amount: Number(eInvoiceAdjustmentDiscount || 0),
      tax_fee_amount: Number(eInvoiceAdjustmentTaxFee || 0),
      fee_other_amount: Number(eInvoiceAdjustmentFeeOther || 0),
      vat_rate: Number(eInvoiceAdjustmentVatRate || 0),
      adjustment_reason: eInvoiceAdjustmentReason,
      issue_official: !!issueOfficial,
    };
  };

  buildBillAdjustmentPayload = () => {
    const {
      eInvoiceAdjustmentInvoice,
      eInvoiceAdjustmentItems,
      eInvoiceAdjustmentDiscount,
      eInvoiceAdjustmentTaxFee,
      eInvoiceAdjustmentFeeOther,
      eInvoiceAdjustmentReason,
    } = this.state;

    const items = eInvoiceAdjustmentItems.map((item, index) => ({
      ...item,
      line_number: index + 1,
      quantity: Number(item.quantity || 0),
      unit_price: Number(item.unit_price || 0),
    }));
    const subtotal = items.reduce(
      (sum, item) => sum + Number(item.quantity || 0) * Number(item.unit_price || 0),
      0,
    );

    return {
      bill_id: eInvoiceAdjustmentInvoice?.bill_id,
      items,
      subtotal,
      discount_amount: Number(eInvoiceAdjustmentDiscount || 0),
      tax_fee_amount: Number(eInvoiceAdjustmentTaxFee || 0),
      fee_other_amount: Number(eInvoiceAdjustmentFeeOther || 0),
      adjustment_reason: eInvoiceAdjustmentReason,
    };
  };

  getEInvoiceAdjustmentTargetTotals = () => {
    const {
      eInvoiceAdjustmentItems,
      eInvoiceAdjustmentDiscount,
      eInvoiceAdjustmentTaxFee,
      eInvoiceAdjustmentFeeOther,
      eInvoiceAdjustmentVatRate,
    } = this.state;
    const subtotal = eInvoiceAdjustmentItems.reduce(
      (sum, item) =>
        sum + Number(item.quantity || 0) * Number(item.unit_price || 0),
      0,
    );
    const discount = Number(eInvoiceAdjustmentDiscount || 0);
    const taxFee = Number(eInvoiceAdjustmentTaxFee || 0);
    const feeOther = Number(eInvoiceAdjustmentFeeOther || 0);
    const vatRate = Number(eInvoiceAdjustmentVatRate || 0);
    const taxableAmount = Math.max(0, subtotal - discount);
    const vatAmount =
      vatRate > 0 ? Math.round((taxableAmount * vatRate) / 100) : 0;

    return {
      subtotal,
      discount,
      tax_fee: taxFee,
      fee_other: feeOther,
      vat_amount: vatAmount,
      total: Math.round(taxableAmount + vatAmount + taxFee + feeOther),
    };
  };

  scheduleEInvoiceAdjustmentPreview = () => {
    if (this.eInvoiceAdjustmentPreviewTimer) {
      window.clearTimeout(this.eInvoiceAdjustmentPreviewTimer);
    }

    this.eInvoiceAdjustmentPreviewTimer = window.setTimeout(() => {
      this.refreshEInvoiceAdjustmentPreview();
    }, 500);
  };

  updateEInvoiceAdjustmentField = (field, value) => {
    this.setState({ [field]: value }, this.scheduleEInvoiceAdjustmentPreview);
  };

  openEInvoiceAdjustmentModal = (invoice) => {
    const eInvoice = invoice?.e_invoice;
    if (!eInvoice?.id || !["issued", "signed", "sent"].includes(eInvoice.status)) return;

    const canIssueOfficial = this.supportsEInvoiceAdjustment();
    this.setState(
      {
        eInvoiceAdjustmentModalOpen: true,
        eInvoiceAdjustmentMode: "einvoice",
        eInvoiceAdjustmentInvoice: invoice,
        eInvoiceAdjustmentItems: this.buildEInvoiceAdjustmentItems(invoice),
        eInvoiceAdjustmentDiscount: Number(invoice?.totals?.discount || 0),
        eInvoiceAdjustmentTaxFee: Number(invoice?.totals?.tax_fee || 0),
        eInvoiceAdjustmentFeeOther: Number(invoice?.totals?.fee_other || 0),
        eInvoiceAdjustmentVatRate:
          eInvoice.vat_rate !== undefined && eInvoice.vat_rate !== null
            ? eInvoice.vat_rate
            : this.getDefaultEInvoiceVatRate(),
        eInvoiceAdjustmentReason: "",
        eInvoiceAdjustmentIssueOfficial: canIssueOfficial,
        eInvoiceAdjustmentPreview: null,
        eInvoiceAdjustmentProductSearch: "",
      },
      () => {
        this.refreshEInvoiceAdjustmentPreview();
        this.fetchEInvoiceAdjustmentProducts("");
      },
    );
  };

  openSePayCorrectionComposer = (invoice, mode = "adjustment") => {
    const eInvoice = invoice?.e_invoice;
    if (!eInvoice?.id || eInvoice.provider !== "sepay") return;
    sessionStorage.setItem(
      "vmass:einvoice-correction-launch",
      JSON.stringify({ invoiceId: eInvoice.id, mode }),
    );
    if (this.props.history?.push) {
      this.props.history.push("/app/pages/einvoice");
      return;
    }
    window.location.assign("/app/pages/einvoice");
  };

  openBillAdjustmentModal = (invoice) => {
    if (!invoice || invoice.is_cancelled) return;

    this.setState(
      {
        eInvoiceAdjustmentModalOpen: true,
        eInvoiceAdjustmentMode: "bill",
        eInvoiceAdjustmentInvoice: invoice,
        eInvoiceAdjustmentItems: this.buildEInvoiceAdjustmentItems(invoice),
        eInvoiceAdjustmentDiscount: Number(invoice?.totals?.discount || 0),
        eInvoiceAdjustmentTaxFee: Number(invoice?.totals?.tax_fee || 0),
        eInvoiceAdjustmentFeeOther: Number(invoice?.totals?.fee_other || 0),
        eInvoiceAdjustmentVatRate: 0,
        eInvoiceAdjustmentReason: "",
        eInvoiceAdjustmentIssueOfficial: false,
        eInvoiceAdjustmentPreview: null,
        eInvoiceAdjustmentProductSearch: "",
      },
      () => {
        this.refreshEInvoiceAdjustmentPreview();
        this.fetchEInvoiceAdjustmentProducts("");
      },
    );
  };

  closeEInvoiceAdjustmentModal = () => {
    if (this.state.isSubmittingEInvoiceAdjustment) return;

    if (this.eInvoiceAdjustmentPreviewTimer) {
      window.clearTimeout(this.eInvoiceAdjustmentPreviewTimer);
      this.eInvoiceAdjustmentPreviewTimer = null;
    }
    if (this.eInvoiceAdjustmentProductSearchTimer) {
      window.clearTimeout(this.eInvoiceAdjustmentProductSearchTimer);
      this.eInvoiceAdjustmentProductSearchTimer = null;
    }

    this.setState({
      eInvoiceAdjustmentModalOpen: false,
      eInvoiceAdjustmentMode: "einvoice",
      eInvoiceAdjustmentInvoice: null,
      eInvoiceAdjustmentItems: [],
      eInvoiceAdjustmentDiscount: "",
      eInvoiceAdjustmentTaxFee: "",
      eInvoiceAdjustmentFeeOther: "",
      eInvoiceAdjustmentVatRate: this.getDefaultEInvoiceVatRate(),
      eInvoiceAdjustmentReason: "",
      eInvoiceAdjustmentIssueOfficial: false,
      eInvoiceAdjustmentPreview: null,
      eInvoiceAdjustmentProducts: [],
      eInvoiceAdjustmentProductSearch: "",
      eInvoiceAdjustmentSelectedProductKey: "",
      isLoadingEInvoiceAdjustmentProducts: false,
      isPreviewingEInvoiceAdjustment: false,
    });
  };

  updateEInvoiceAdjustmentItem = (index, field, value) => {
    this.setState((prev) => ({
      eInvoiceAdjustmentItems: prev.eInvoiceAdjustmentItems.map((item, itemIndex) =>
        itemIndex === index ? { ...item, [field]: value } : item,
      ),
    }), this.scheduleEInvoiceAdjustmentPreview);
  };

  refreshEInvoiceAdjustmentPreview = () => {
    const invoice = this.state.eInvoiceAdjustmentInvoice;
    const isBillAdjustment = this.state.eInvoiceAdjustmentMode === "bill";
    const eInvoice = invoice?.e_invoice;
    if (!isBillAdjustment && !eInvoice?.id) return;
    if (isBillAdjustment && !invoice?.bill_id) return;

    const tokenStr = localStorage.getItem("access_token");
    this.setState({ isPreviewingEInvoiceAdjustment: true });

    axios
      .post(
        isBillAdjustment
          ? `${END_POINT}/bill/adjustment-preview`
          : `${END_POINT}/api/einvoice/${eInvoice.id}/adjustment-preview`,
        isBillAdjustment
          ? this.buildBillAdjustmentPayload()
          : this.buildEInvoiceAdjustmentPayload(false),
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        this.setState({
          eInvoiceAdjustmentPreview: res.data?.data || null,
          isPreviewingEInvoiceAdjustment: false,
        });
      })
      .catch((err) => {
        this.setState({ isPreviewingEInvoiceAdjustment: false });
        NotificatioErrController(
          err.response?.data?.responseText || "Có lỗi xảy ra khi xem trước điều chỉnh.",
        );
      });
  };

  submitEInvoiceAdjustment = () => {
    const invoice = this.state.eInvoiceAdjustmentInvoice;
    const isBillAdjustment = this.state.eInvoiceAdjustmentMode === "bill";
    const eInvoice = invoice?.e_invoice;
    const issueOfficial =
      this.state.eInvoiceAdjustmentIssueOfficial &&
      this.supportsEInvoiceAdjustment();

    if (!isBillAdjustment && !eInvoice?.id) return;
    if (isBillAdjustment && !invoice?.bill_id) return;
    if (!this.state.eInvoiceAdjustmentReason.trim()) {
      NotificatioErrController("Vui lòng nhập lý do điều chỉnh.");
      return;
    }

    const tokenStr = localStorage.getItem("access_token");
    this.setState({ isSubmittingEInvoiceAdjustment: true });

    axios
      .post(
        isBillAdjustment
          ? `${END_POINT}/bill/adjustment`
          : `${END_POINT}/api/einvoice/${eInvoice.id}/adjustments`,
        isBillAdjustment
          ? this.buildBillAdjustmentPayload()
          : this.buildEInvoiceAdjustmentPayload(issueOfficial),
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        NotificatioSucController(
          res.data?.message ||
            (isBillAdjustment ? "Đã điều chỉnh hóa đơn" : "Đã lưu hóa đơn điều chỉnh"),
        );
        this.setState(
          {
            eInvoiceAdjustmentModalOpen: false,
            eInvoiceAdjustmentMode: "einvoice",
            eInvoiceAdjustmentInvoice: null,
            eInvoiceAdjustmentItems: [],
            eInvoiceAdjustmentPreview: null,
            isSubmittingEInvoiceAdjustment: false,
          },
          this.dataListRender,
        );
      })
      .catch((err) => {
        this.setState({ isSubmittingEInvoiceAdjustment: false });
        NotificatioErrController(
          err.response?.data?.responseText || "Có lỗi xảy ra khi lưu hóa đơn điều chỉnh.",
        );
      });
  };

  issueExistingEInvoice = (invoice) => {
    const eInvoice = invoice?.e_invoice;
    if (!eInvoice?.id) {
      this.openEInvoiceIssueModal(invoice);
      return;
    }

    const tokenStr = localStorage.getItem("access_token");
    const userId = this.getEInvoiceUserId();

    axios
      .post(
        `${END_POINT}/api/einvoice/${eInvoice.id}/issue-official`,
        { user_id: userId },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        NotificatioSucController(res.data?.message || "Đã phát hành hóa đơn điện tử");
        this.dataListRender();
      })
      .catch((err) => {
        NotificatioErrController(
          err.response?.data?.responseText || "Có lỗi xảy ra khi phát hành HĐĐT.",
        );
      });
  };

  checkEInvoiceStatus = (invoice) => {
    const eInvoice = invoice?.e_invoice;
    if (!eInvoice?.id) return;

    const tokenStr = localStorage.getItem("access_token");
    const userId = this.getEInvoiceUserId();

    axios
      .get(`${END_POINT}/api/einvoice/${eInvoice.id}/status?user_id=${userId}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then(() => {
        NotificatioSucController("Đã cập nhật trạng thái hóa đơn điện tử");
        this.dataListRender();
      })
      .catch((err) => {
        NotificatioErrController(
          err.response?.data?.responseText || "Có lỗi xảy ra khi kiểm tra trạng thái.",
        );
      });
  };

  viewEInvoicePdf = async (invoice, download = false) => {
    const eInvoice = invoice?.e_invoice;
    if (!eInvoice?.id) return;

    const userId = this.getEInvoiceUserId();
    const tokenStr = localStorage.getItem("access_token");
    const action = download ? "download" : "pdf";

    try {
      const response = await axios.get(
        `${END_POINT}/api/einvoice/${eInvoice.id}/${action}?user_id=${userId}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
          responseType: "blob",
        },
      );
      const blobUrl = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" }),
      );

      if (download) {
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `einvoice-${eInvoice.id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        return;
      }

      window.open(blobUrl, "_blank");
    } catch (err) {
      NotificatioErrController(
        err.response?.data?.responseText || "Không thể mở hóa đơn điện tử.",
      );
    }
  };

  sendEInvoiceEmail = (invoice) => {
    const eInvoice = invoice?.e_invoice;
    if (!eInvoice?.id) return;

    const email = window.prompt("Nhập email nhận hóa đơn", "");
    if (!email) return;

    const tokenStr = localStorage.getItem("access_token");
    axios
      .post(
        `${END_POINT}/api/einvoice/${eInvoice.id}/send-email`,
        {
          user_id: this.getEInvoiceUserId(),
          email,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then(() => {
        NotificatioSucController("Đã gửi email hóa đơn điện tử");
        this.dataListRender();
      })
      .catch((err) => {
        NotificatioErrController(
          err.response?.data?.responseText || "Có lỗi xảy ra khi gửi email.",
        );
      });
  };

  renderSummaryCards = () => {
    const { summary } = this.state;
    const cards = [
      {
        key: "total_bills",
        label: "Tổng đơn",
        value: AddCommaNumber(summary.total_bills || 0),
        change: summary.changes?.total_bills,
        icon: "iconsminds-receipt-4",
        tone: "blue",
      },
      {
        key: "revenue_amount",
        label: "Doanh thu",
        value: (
          <>
            <span className="d-none d-md-inline">{formatMoney(summary.revenue_amount)}</span>
            <span className="d-inline d-md-none">{formatCompactMoney(summary.revenue_amount)}</span>
          </>
        ),
        change: summary.changes?.revenue_amount,
        icon: "iconsminds-money-bag",
        tone: "green",
      },
      {
        key: "debt_amount",
        label: "Công nợ",
        value: (
          <>
            <span className="d-none d-md-inline">{formatMoney(summary.debt_amount)}</span>
            <span className="d-inline d-md-none">{formatCompactMoney(summary.debt_amount)}</span>
          </>
        ),
        change: summary.changes?.debt_amount,
        icon: "iconsminds-credit-card",
        tone: "orange",
      },
      {
        key: "cancelled_bills",
        label: "Đã hủy",
        value: AddCommaNumber(summary.cancelled_bills || 0),
        change: summary.changes?.cancelled_bills,
        icon: "simple-icon-close",
        tone: "red",
      },
    ];

    return (
      <Row className="order-dashboard-kpis mx-n1">
        {cards.map((card) => (
          <Col key={card.key} xs="3" sm="6" xl="3" className="px-1 mb-3">
            <Card className="order-dashboard-kpi-card">
              <CardBody className="p-2 p-md-3">
                <div className="w-100 text-center text-md-left">
                  <div className="order-dashboard-kpi-label mb-1 mb-md-2">{card.label}</div>
                  <div className="order-dashboard-kpi-value">{card.value}</div>
                  <div
                    className={classNames("order-dashboard-kpi-change d-none d-md-block", {
                      "is-negative": Number(card.change || 0) < 0,
                    })}
                  >
                    {formatChange(card.change)} so với hôm qua
                  </div>
                </div>
                <div className={`order-dashboard-kpi-icon is-${card.tone} d-none d-md-flex`}>
                  <i className={card.icon} />
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    );
  };

  renderToolbar = () => {
    const { filters, datePickerOpen } = this.state;
    const sortOption =
      SORT_OPTIONS.find((option) => option.key === filters.sortBy) ||
      SORT_OPTIONS[0];
    const dateLabel = filters.all
      ? "Tất cả"
      : filters.date_start === filters.date_end
        ? moment(filters.date_start).format("DD/MM/YYYY")
        : `${moment(filters.date_start).format("DD/MM/YYYY")} - ${moment(
            filters.date_end,
          ).format("DD/MM/YYYY")}`;

    return (
      <div className="order-dashboard-toolbar">
        <div className="order-dashboard-toolbar-left">
          <Button
            id="order-dashboard-date-filter"
            color="light"
            className="order-dashboard-date-button"
            onClick={() => this.setState({ datePickerOpen: !datePickerOpen })}
          >
            <i className="simple-icon-calendar mr-2" />
            {dateLabel}
          </Button>
          <Popover
            isOpen={datePickerOpen}
            target="order-dashboard-date-filter"
            toggle={() => this.setState({ datePickerOpen: !datePickerOpen })}
            placement="bottom-start"
            className="order-dashboard-date-popover"
          >
            <PopoverBody>
              <div className="custom-daterange__container">
                <div className="date-label">
                  <DateRangePicker
                    initialDateRange={{
                      startDate: filters.all
                        ? moment(ALL_ORDERS_DATE)
                        : moment(filters.date_start),
                      endDate: filters.all
                        ? moment(ALL_ORDERS_DATE)
                        : moment(filters.date_end),
                    }}
                    open={true}
                    onChange={this.onDateRangeChange}
                    rangesPosition="right"
                    definedRanges={[
                      {
                        label: "Hôm nay",
                        startDate: moment(),
                        endDate: moment(),
                      },
                      {
                        label: "Hôm qua",
                        startDate: moment().subtract(1, "day"),
                        endDate: moment().subtract(1, "day"),
                      },
                      {
                        label: "Tuần này",
                        startDate: moment().startOf("isoWeek"),
                        endDate: moment().endOf("isoWeek"),
                      },
                      {
                        label: "Tuần trước",
                        startDate: moment().subtract(1, "week").startOf("isoWeek"),
                        endDate: moment().subtract(1, "week").endOf("isoWeek"),
                      },
                      {
                        label: "Tháng này",
                        startDate: moment().startOf("month"),
                        endDate: moment().endOf("month"),
                      },
                      {
                        label: "Tháng trước",
                        startDate: moment().subtract(1, "month").startOf("month"),
                        endDate: moment().subtract(1, "month").endOf("month"),
                      },
                      {
                        label: "Tất cả",
                        startDate: moment(ALL_ORDERS_DATE),
                        endDate: moment(ALL_ORDERS_DATE),
                      },
                    ]}
                  />
                </div>
              </div>
            </PopoverBody>
          </Popover>
          {ORDER_DATE_PRESETS.map((preset) => (
            <Button
              key={preset.key}
              color={this.isDatePresetActive(preset.key) ? "primary" : "light"}
              onClick={() => this.setDatePreset(preset.key)}
            >
              {preset.label}
            </Button>
          ))}
          <Button
            color="light"
            onClick={() => this.setState({ datePickerOpen: true })}
          >
            Tùy chọn <i className="simple-icon-equalizer ml-2" />
          </Button>
        </div>
        <div className="order-dashboard-toolbar-right">
          {this.isEInvoiceEnabled() && (
            <Button
              color="primary"
              className="order-dashboard-einvoice-btn d-block d-md-none mr-2"
              tag="a"
              href="/app/pages/einvoice"
            >
              <i className="simple-icon-doc mr-1" /> Danh sách HĐĐT
            </Button>
          )}
          <ButtonDropdown
            isOpen={this.state.sortOpen}
            toggle={() => this.setState({ sortOpen: !this.state.sortOpen })}
          >
            <DropdownToggle color="light" caret>
              Sắp xếp: {sortOption.label}
            </DropdownToggle>
            <DropdownMenu right>
              {SORT_OPTIONS.map((option) => (
                <DropdownItem
                  key={option.key}
                  onClick={() => this.setFilters({ sortBy: option.key })}
                >
                  {option.label}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </ButtonDropdown>
          {/* <Button color="primary" outline className="order-dashboard-icon-button">
            <i className="simple-icon-list" />
          </Button>
          <Button color="light" className="order-dashboard-icon-button">
            <i className="simple-icon-grid" />
          </Button> */}
        </div>
      </div>
    );
  };

  renderStatusFilters = () => {
    const { filters, summary } = this.state;
    const counts = summary.status_counts || {};
    const isEInvoiceEnabled = this.isEInvoiceEnabled();

    const activeFilters = STATUS_FILTERS.filter(
      (item) => item.key !== "e_invoice_issued" || isEInvoiceEnabled
    );

    return (
      <div className="order-dashboard-status-container">
        <div className="order-dashboard-status-row">
          {activeFilters.map((item) => (
            <Button
              key={item.key}
              color={filters.status === item.key ? item.tone : "light"}
              outline={filters.status !== item.key}
              className={`order-dashboard-status-chip is-${item.tone}`}
              onClick={() => this.setFilters({ status: item.key })}
            >
              {item.label}
              <span>{AddCommaNumber(counts[item.key] || 0)}</span>
            </Button>
          ))}
        </div>
        {/* {isEInvoiceEnabled && (
          <Button
            color="primary"
            className="order-dashboard-einvoice-btn d-none d-md-block"
            tag="a"
            href="/app/pages/einvoice"
          >
            <i className="simple-icon-doc mr-2" /> Danh sách HĐĐT
          </Button>
        )} */}
      </div>
    );
  };

  renderEInvoiceBadge = (invoice) => {
    if (!this.isEInvoiceEnabled()) return null;
    const meta = this.getEInvoiceMeta(invoice);
    const eInvoice = invoice?.e_invoice;

    return (
      <Badge
        color={meta.color}
        pill
        className="order-dashboard-einvoice-badge"
        title={eInvoice?.status === "error" ? eInvoice.error_message : undefined}
      >
        HĐĐT: {meta.label}
      </Badge>
    );
  };

  renderInvoiceList = () => {
    const { items, activeInvoice, page } = this.state;

    return (
      <Card className="order-dashboard-list-panel">
        <div className="order-dashboard-list-head">
          <div className="d-flex align-items-center">
            <strong>{AddCommaNumber(page.totalItem)} hóa đơn</strong>
          </div>
          {/* <Button color="light" size="sm">
            <i className="simple-icon-plus mr-1" /> Bộ lọc khác
          </Button> */}
        </div>
        <div className="order-dashboard-list-body">
          {items.length ? (
            items.map((invoice) => this.renderInvoiceListItem(invoice, activeInvoice))
          ) : (
            <div className="order-dashboard-empty">
              <i className="iconsminds-receipt-4" />
              <p>Không có hóa đơn trong khoảng thời gian này.</p>
            </div>
          )}
        </div>
        <div className="order-dashboard-list-footer">
          <Pagination
            currentPage={page.currentPage}
            totalPage={page.totalPage}
            onChangePage={this.onChangePage}
          />
          <Input
            type="select"
            value={page.selectedPageSize}
            onChange={this.onChangePageSize}
          >
            {page.pageSizes.map((size) => (
              <option key={size} value={size}>
                {size} / trang
              </option>
            ))}
          </Input>
        </div>
      </Card>
    );
  };

  renderInvoiceListItem = (invoice, activeInvoice) => {
    const isActive = activeInvoice?.pin === invoice.pin;

    return (
      <div
        key={invoice.pin}
        className={classNames("order-dashboard-list-item", {
          active: isActive,
          cancelled: invoice.is_cancelled,
        })}
        onClick={() => this.onSelectInvoice(invoice)}
      >
        {/* DESKTOP LAYOUT */}
        <div className="order-dashboard-list-details-container">
          <div className="order-dashboard-list-row-1">
            <div className="order-dashboard-list-code">
              <strong>#{invoice.code}</strong>
              <span className="order-time">{invoice.time || "--"}</span>
            </div>
          </div>

          <div className="order-dashboard-list-main">
            <div className="order-dashboard-list-product">
              {invoice.customer?.name || "Khách lẻ"}
              {invoice.customer?.phone ? ` - ${invoice.customer.phone}` : ""}
            </div>
            {invoice.customer?.address && invoice.customer.address.trim() !== "" && (
              <div className="order-dashboard-list-customer">
                {invoice.customer.address}
              </div>
            )}
          </div>

          <div className="order-dashboard-list-row-3">
            <div className="order-dashboard-list-channel">
              <Badge pill>{invoice.channel}</Badge>
              {this.renderEInvoiceBadge(invoice)}
            </div>
          </div>
        </div>
        <div className="order-dashboard-list-total">
          <strong>{formatMoney(invoice.totals?.total)}</strong>
          <Badge color={getStatusClass(invoice.status_key)} pill>
            {invoice.status_label}
          </Badge>
        </div>

        {/* MOBILE 2-COLUMN LAYOUT */}
        <div className="order-dashboard-list-col-left">
          <div className="order-dashboard-list-code-row">
            <strong>#{invoice.code}</strong>
            <span className="order-time">{invoice.time || "--"}</span>
          </div>
          <div className="order-dashboard-list-customer-row">
            <span className="customer-name">{invoice.customer?.name || "Khách lẻ"}</span>
            {invoice.customer?.phone && (
              <span className="customer-phone"> - {invoice.customer.phone}</span>
            )}
          </div>
          {invoice.customer?.address && invoice.customer.address.trim() !== "" && (
            <div className="order-dashboard-list-address-row">
              {invoice.customer.address}
            </div>
          )}
        </div>

        <div className="order-dashboard-list-col-right">
          <div className="order-dashboard-list-total-row">
            <strong>{formatMoney(invoice.totals?.total)}</strong>
          </div>
          <div className="order-dashboard-list-badges-row">
            <Badge pill color="secondary" className="order-channel-badge">{invoice.channel}</Badge>
            <Badge color={getStatusClass(invoice.status_key)} pill className="order-status-badge">
              {invoice.status_label}
            </Badge>
            {this.renderEInvoiceBadge(invoice)}
          </div>
        </div>
      </div>
    );
  };

  renderDetailPanel = () => {
    const { activeInvoice } = this.state;

    if (!activeInvoice) {
      return (
        <Card className="order-dashboard-detail-panel">
          <CardBody className="order-dashboard-detail-empty">
            <i className="iconsminds-receipt-4" />
            <p>Chọn một hóa đơn để xem chi tiết.</p>
          </CardBody>
        </Card>
      );
    }

    return (
      <Card className="order-dashboard-detail-panel">
        {this.renderDetailHeader(activeInvoice)}
        {this.renderDetailTabs(activeInvoice)}
      </Card>
    );
  };

  renderEInvoiceDropdownItems = (invoice) => {
    const eInvoice = invoice.e_invoice;
    const hasSuccessfulSePayInvoice =
      eInvoice?.provider === "sepay" &&
      eInvoice?.provider_status === "success" &&
      ["issued", "signed", "sent"].includes(eInvoice?.status);
    const billAdjustmentItem = !invoice.is_cancelled && !eInvoice ? (
      <>
        <DropdownItem divider />
        <DropdownItem onClick={() => this.openBillAdjustmentModal(invoice)}>
          <i className="simple-icon-pencil mr-2" />
          Điều chỉnh hóa đơn
        </DropdownItem>
      </>
    ) : null;

    if (!this.isEInvoiceEnabled()) return billAdjustmentItem;

    if (!eInvoice) {
      if (invoice.is_cancelled) return billAdjustmentItem;

      return (
        <>
          {billAdjustmentItem}
          {!invoice.is_cancelled && <DropdownItem divider />}
          <DropdownItem onClick={() => this.openEInvoiceIssueModal(invoice)}>
            <i className="simple-icon-doc mr-2" />
            Xuất hóa đơn điện tử
          </DropdownItem>
        </>
      );
    }

    const canIssue = eInvoice.status === "draft" || eInvoice.status === "error";
    const canReadPdf = eInvoice.status !== "draft";
    const canSendEmail =
      eInvoice.status !== "draft" && eInvoice.status !== "cancelled";
    const canAdjust = ["issued", "signed", "sent"].includes(eInvoice.status);

    return (
      <>
        {billAdjustmentItem}
        {billAdjustmentItem && <DropdownItem divider />}
        {canIssue && (
          <DropdownItem onClick={() => this.issueExistingEInvoice(invoice)}>
            <i className="simple-icon-check mr-2" />
            {eInvoice.status === "error" ? "Phát hành lại HĐĐT" : "Phát hành HĐĐT"}
          </DropdownItem>
        )}
        {canIssue && (
          <DropdownItem onClick={() => this.openEInvoiceIssueModal(invoice, "edit")}>
            <i className="simple-icon-note mr-2" />
            Sửa thông tin HĐĐT
          </DropdownItem>
        )}
        {canReadPdf && (
          <DropdownItem onClick={() => this.viewEInvoicePdf(invoice)}>
            <i className="simple-icon-doc mr-2" />
            Xem PDF HĐĐT
          </DropdownItem>
        )}
        {canReadPdf && (
          <DropdownItem onClick={() => this.viewEInvoicePdf(invoice, true)}>
            <i className="simple-icon-cloud-download mr-2" />
            Tải PDF HĐĐT
          </DropdownItem>
        )}
        {canSendEmail && (
          <DropdownItem onClick={() => this.sendEInvoiceEmail(invoice)}>
            <i className="simple-icon-envelope mr-2" />
            Gửi email HĐĐT
          </DropdownItem>
        )}
        {hasSuccessfulSePayInvoice && (
          <>
            <DropdownItem onClick={() => this.openSePayCorrectionComposer(invoice, "adjustment")}>
              <i className="simple-icon-pencil mr-2" />
              Điều chỉnh HĐĐT SePay
            </DropdownItem>
            <DropdownItem onClick={() => this.openSePayCorrectionComposer(invoice, "replacement")}>
              <i className="simple-icon-reload mr-2" />
              Thay thế HĐĐT SePay
            </DropdownItem>
          </>
        )}
        {canAdjust && !hasSuccessfulSePayInvoice && (
          <DropdownItem onClick={() => this.openEInvoiceAdjustmentModal(invoice)}>
            <i className="simple-icon-pencil mr-2" />
            Điều chỉnh HĐĐT
          </DropdownItem>
        )}
        <DropdownItem onClick={() => this.checkEInvoiceStatus(invoice)}>
          <i className="simple-icon-refresh mr-2" />
          Kiểm tra trạng thái HĐĐT
        </DropdownItem>
      </>
    );
  };

  renderDetailHeader = (invoice) => {
    return (
      <div className="order-dashboard-detail-head">
        <div className="order-dashboard-detail-title">
          <div>
            <h2>Hóa đơn #{invoice.code}</h2>
            <Badge color={getStatusClass(invoice.status_key)} pill className="mr-2">
              {invoice.status_label}
            </Badge>
            {this.renderEInvoiceBadge(invoice)}
          </div>
          <div className="order-dashboard-detail-meta">
            <span>
              <i className="simple-icon-calendar mr-1" />
              {formatDateTime(invoice.date, invoice.time)}
            </span>
            <span>
              <i className="iconsminds-shop-4 mr-1" />
              {invoice.channel}
            </span>
            <span>
              <i className="simple-icon-user mr-1" />
              Nhân viên: {invoice.staff?.name || "Chưa ghi nhận"}
            </span>
          </div>
        </div>
        <div className="order-dashboard-detail-actions">
          {!invoice.is_cancelled && this.canManageOrderDebt() && this.getCustomerDebt(invoice) > 0 && (
            <Button
              color="success"
              onClick={() => this.openRepayModal(invoice)}
            >
              <i className="iconsminds-coins mr-1" />
              Trả nợ
            </Button>
          )}
          {!invoice.is_cancelled && !invoice.has_debt && this.canManageOrderDebt() && (
            <Button
              color="success"
              outline
              onClick={() => this.openDebtModal(invoice)}
            >
              Ghi công nợ
            </Button>
          )}
          {/* <Button color="primary" outline onClick={() => this.callPreviewAction("printInvoice")}>
            <i className="simple-icon-printer mr-1" /> In
          </Button>
          <Button color="primary" outline onClick={() => this.callPreviewAction("shareImage")}>
            <i className="simple-icon-share mr-1" /> Chia sẻ
          </Button> */}
          <ButtonDropdown
            isOpen={this.state.moreOpen}
            toggle={() => this.setState({ moreOpen: !this.state.moreOpen })}
          >
            <DropdownToggle color="primary" outline caret>
              Khác
            </DropdownToggle>
            <DropdownMenu right>
              {this.renderEInvoiceDropdownItems(invoice)}
              {invoice.is_cancelled ? (
                <>
                  <DropdownItem onClick={() => this.onRestoreBill(invoice.pin)}>
                    <i className="simple-icon-action-undo mr-2" />
                    Khôi phục hóa đơn
                  </DropdownItem>
                  <DropdownItem
                    className="text-danger"
                    onClick={() => this.onDestroyBill(invoice.pin)}
                  >
                    <i className="simple-icon-trash mr-2" />
                    Xóa vĩnh viễn
                  </DropdownItem>
                </>
              ) : (
                <DropdownItem
                  className="text-danger"
                  onClick={() => this.onDeleteBill(invoice.pin)}
                >
                  <i className="simple-icon-trash mr-2" />
                  Hủy hóa đơn bán hàng
                </DropdownItem>
              )}
            </DropdownMenu>
          </ButtonDropdown>
        </div>
      </div>
    );
  };

  renderDetailTabs = (invoice) => {
    const { detailTab } = this.state;
    const detailTabs = DETAIL_TABS.filter(
      (tab) => tab.key !== "einvoice" || this.isEInvoiceEnabled(),
    );
    const activeDetailTab = detailTabs.some((tab) => tab.key === detailTab)
      ? detailTab
      : "info";

    return (
      <>
        <Nav tabs className="order-dashboard-detail-tabs">
          {detailTabs.map((tab) => (
            <NavItem key={tab.key}>
              <NavLink
                className={classNames({ active: activeDetailTab === tab.key })}
                onClick={() => this.setDetailTab(tab.key, invoice)}
              >
                {tab.labelId ? <IntlMessages id={tab.labelId} /> : tab.label}
                {tab.key === "products" ? ` (${invoice.products.length})` : ""}
                {tab.key === "einvoice" && invoice.e_invoice_count > 1
                  ? ` (${invoice.e_invoice_count})`
                  : ""}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <TabContent
          activeTab={activeDetailTab}
          className={classNames("order-dashboard-detail-content", {
            "order-dashboard-detail-content-preview":
              activeDetailTab === "preview",
          })}
        >
          <TabPane tabId="info">{this.renderInfoTab(invoice)}</TabPane>
          <TabPane tabId="products">{this.renderProductsTab(invoice)}</TabPane>
          <TabPane tabId="payment">{this.renderPaymentTab(invoice)}</TabPane>
          {this.isEInvoiceEnabled() && (
            <TabPane tabId="einvoice">{this.renderEInvoiceTab(invoice)}</TabPane>
          )}
          <TabPane tabId="history">{this.renderHistoryTab(invoice)}</TabPane>
          <TabPane tabId="preview">{this.renderPreviewTab(invoice)}</TabPane>
        </TabContent>
      </>
    );
  };

  renderInfoTab = (invoice) => {
    const invoiceDebt = Number(invoice.totals?.debt || 0);
    const customerDebt = this.getCustomerDebt(invoice);
    const hasOtherDebt = customerDebt > invoiceDebt;

    return (
      <Row>
        <Col lg="6" className="mb-3">
          <div className="order-dashboard-info-card">
            <h3>Thông tin chung</h3>
            <InfoRow label="Mã hóa đơn" value={`#${invoice.code}`} />
            <InfoRow label="Thời gian" value={formatDateTime(invoice.date, invoice.time)} />
            <InfoRow label="Kênh bán" value={invoice.channel} badge />
            <InfoRow label="Khách hàng" value={invoice.customer?.name || "Khách lẻ"} />
            <InfoRow label="Công nợ" value={formatMoney(invoiceDebt)} danger={invoiceDebt > 0} />
            {hasOtherDebt && (
              <InfoRow label="Tổng công nợ" value={formatMoney(customerDebt)} danger />
            )}
            <InfoRow label="Điện thoại" value={invoice.customer?.phone || "--"} />
            <InfoRow label="Địa chỉ" value={invoice.customer?.address || "--"} />
            <InfoRow label="Nhân viên" value={invoice.staff?.name || "Chưa ghi nhận"} />
          </div>
        </Col>
        <Col lg="6" className="mb-3">
          <div className="order-dashboard-note-card">
            <h3>Ghi chú</h3>
            <p>{invoice.orders?.find((order) => order.note)?.note || "Không có ghi chú"}</p>
          </div>
          {invoice.shipping_order && (
            <div className="order-dashboard-info-card">
              <h3>Giao hàng</h3>
              <InfoRow label="Mã vận đơn" value={invoice.shipping_order.tracking_code || "--"} />
              <InfoRow
                label="Trạng thái"
                value={invoice.shipping_order.status_text || invoice.shipping_order.status || "--"}
              />
              <InfoRow
                label="Người nhận"
                value={invoice.shipping_order.receiver_name || "--"}
              />
              <InfoRow
                label="Địa chỉ"
                value={invoice.shipping_order.receiver_address || "--"}
              />
            </div>
          )}
        </Col>
      </Row>
    );
  };

  renderProductsTab = (invoice) => {
    return (
      <div className="order-dashboard-table-card order-dashboard-products-table-card">
        <table className="table order-dashboard-products-table">
          <thead>
            <tr>
              <th className="text-center">#</th>
              <th>Tên sản phẩm</th>
              <th className="text-center">SL</th>
              <th className="text-right">Đơn giá</th>
              <th className="text-right">Thành tiền</th>
            </tr>
          </thead>
          <tbody>
            {invoice.products.map((item, index) => {
              const variantTags = getVariantTags(item);

              return (
                <tr key={`${item.name}-${index}`}>
                  <td className="text-center order-dashboard-products-index" data-label="#">
                    {index + 1}
                  </td>
                  <td data-label="Tên sản phẩm">
                    <div className="order-dashboard-product-cell">
                      <ProductImage
                        image={item.image}
                        alt={item.name}
                        fnbType={item.fnb_type}
                        className="order-dashboard-product-image"
                        iconSize="24px"
                      />
                      <div className="order-dashboard-product-meta">
                        <strong>{item.name}</strong>
                        {variantTags.length ? (
                          <div className="order-dashboard-product-variants">
                            {variantTags.map((tag, tagIndex) => (
                              <span
                                className="order-dashboard-product-variant"
                                key={`${tag}-${tagIndex}`}
                              >
                                {tag}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span className="order-dashboard-product-unit">
                            {item.sale_unit || "--"}
                          </span>
                        )}
                      </div>
                    </div>
                  </td>
                  <td className="text-center" data-label="SL">
                    {item.count}
                  </td>
                  <td className="text-right" data-label="Đơn giá">
                    {formatMoney(item.unit_price)}
                  </td>
                  <td className="text-right" data-label="Thành tiền">
                    {formatMoney(item.total_price)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  renderPaymentTab = (invoice) => {
    const totals = invoice.totals || {};
    const feeOtherName = resolveFeeOtherLabel(
      this.props.intl.messages,
      invoice,
    );

    return (
      <Row>
        <Col lg="7" className="mb-3">
          <div className="order-dashboard-payment-card">
            <h3>Thanh toán</h3>
            <PaymentRow label="Tổng tiền hàng" value={totals.subtotal} />
            <PaymentRow label="Chiết khấu" value={totals.discount} />
            <PaymentRow label="Thuế" value={totals.tax_fee} />
            <PaymentRow label={feeOtherName} value={totals.fee_other} />
            <PaymentRow label="Thành tiền" value={totals.total} strong />
            <PaymentRow label="Đã thanh toán" value={totals.paid} success />
            <PaymentRow label="Còn lại" value={totals.debt} />
            {this.getCustomerDebt(invoice) > 0 && !invoice.is_cancelled && (
              <Button
                color="success"
                block
                className="order-dashboard-repay-inline"
                onClick={() => this.openRepayModal(invoice)}
              >
                <i className="iconsminds-coins mr-1" />
                Trả nợ
              </Button>
            )}
          </div>
        </Col>
        <Col lg="5" className="mb-3">
          <div className="order-dashboard-payment-card">
            <h3>Phương thức thanh toán</h3>
            {(invoice.payment_methods || []).map((method) => (
              <div className="order-dashboard-method-row" key={method}>
                <span>
                  <i className="iconsminds-money-bag mr-2" />
                  {paymentMethodLabels[method] || method}
                </span>
              </div>
            ))}
          </div>
        </Col>
      </Row>
    );
  };

  renderEInvoiceActionButtons = (invoice) => {
    const eInvoice = invoice?.e_invoice;

    if (!this.isEInvoiceEnabled()) return null;

    if (!eInvoice) {
      if (invoice?.is_cancelled) return null;

      return (
        <div className="order-dashboard-einvoice-actions">
          <Button
            color="primary"
            onClick={() => this.openEInvoiceIssueModal(invoice)}
          >
            <i className="simple-icon-doc mr-1" />
            Xuất hóa đơn điện tử
          </Button>
        </div>
      );
    }

    const canIssue = eInvoice.status === "draft" || eInvoice.status === "error";
    const canReadPdf = eInvoice.status !== "draft";
    const canSendEmail =
      eInvoice.status !== "draft" && eInvoice.status !== "cancelled";
    const canAdjust = ["issued", "signed", "sent"].includes(eInvoice.status);
    const hasSuccessfulSePayInvoice =
      eInvoice.provider === "sepay" && eInvoice.provider_status === "success" && canAdjust;

    return (
      <div className="order-dashboard-einvoice-actions">
        {canIssue && (
          <Button
            color="primary"
            onClick={() => this.issueExistingEInvoice(invoice)}
          >
            <i className="simple-icon-check mr-1" />
            {eInvoice.status === "error" ? "Phát hành lại" : "Phát hành"}
          </Button>
        )}
        {canIssue && (
          <Button
            color="light"
            onClick={() => this.openEInvoiceIssueModal(invoice, "edit")}
          >
            <i className="simple-icon-note mr-1" />
            Sửa thông tin
          </Button>
        )}
        {canReadPdf && (
          <Button color="light" onClick={() => this.viewEInvoicePdf(invoice)}>
            <i className="simple-icon-doc mr-1" />
            Xem PDF
          </Button>
        )}
        {canReadPdf && (
          <Button color="light" onClick={() => this.viewEInvoicePdf(invoice, true)}>
            <i className="simple-icon-cloud-download mr-1" />
            Tải PDF
          </Button>
        )}
        {canSendEmail && (
          <Button color="light" onClick={() => this.sendEInvoiceEmail(invoice)}>
            <i className="simple-icon-envelope mr-1" />
            Gửi email
          </Button>
        )}
        {hasSuccessfulSePayInvoice && (
          <>
            <Button
              color="light"
              onClick={() => this.openSePayCorrectionComposer(invoice, "adjustment")}
            >
              <i className="simple-icon-pencil mr-1" />
              Điều chỉnh
            </Button>
            <Button
              color="light"
              onClick={() => this.openSePayCorrectionComposer(invoice, "replacement")}
            >
              <i className="simple-icon-reload mr-1" />
              Thay thế
            </Button>
          </>
        )}
        {canAdjust && !hasSuccessfulSePayInvoice && (
          <Button
            color="light"
            onClick={() => this.openEInvoiceAdjustmentModal(invoice)}
          >
            <i className="simple-icon-pencil mr-1" />
            Điều chỉnh
          </Button>
        )}
        <Button color="light" onClick={() => this.checkEInvoiceStatus(invoice)}>
          <i className="simple-icon-refresh mr-1" />
          Kiểm tra trạng thái
        </Button>
      </div>
    );
  };

  renderEInvoiceAdjustments = () => {
    const { eInvoiceAdjustments, isLoadingEInvoiceAdjustments } = this.state;

    return (
      <div className="order-dashboard-info-card order-dashboard-einvoice-adjustments">
        <h3>Hóa đơn điều chỉnh</h3>
        {isLoadingEInvoiceAdjustments ? (
          <div className="order-dashboard-einvoice-empty is-compact">
            <span className="spinner-border spinner-border-sm mr-2" />
            Đang tải hóa đơn điều chỉnh...
          </div>
        ) : eInvoiceAdjustments.length === 0 ? (
          <p className="text-muted mb-0">Chưa có hóa đơn điều chỉnh.</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-sm mb-0 order-dashboard-einvoice-adjustments-table">
              <thead>
                <tr>
                  <th>Lần</th>
                  <th>Số HĐ</th>
                  <th>Trạng thái</th>
                  <th>Loại</th>
                  <th className="text-right">Chênh lệch</th>
                  <th>Ngày tạo</th>
                  <th className="text-right">Thao tác</th>
                </tr>
              </thead>
              <tbody>
                {eInvoiceAdjustments.map((item) => {
                  const meta = E_INVOICE_STATUS_META[item.status] || {
                    label: item.status || "--",
                    color: "secondary",
                  };
                  const rowInvoice = { e_invoice: item };
                  const canIssue = item.status === "draft" || item.status === "error";
                  const canReadPdf = item.status !== "draft";

                  return (
                    <tr key={item.id}>
                      <td>{item.adjustment_sequence || "--"}</td>
                      <td>
                        <strong>{item.invoice_no || "--"}</strong>
                        <br />
                        <small className="text-muted">{item.invoice_series || "--"}</small>
                      </td>
                      <td>
                        <Badge
                          color={meta.color}
                          pill
                          className="order-dashboard-einvoice-badge"
                          title={item.error_message || undefined}
                        >
                          {meta.label}
                        </Badge>
                      </td>
                      <td>{item.adjustment_direction || "--"}</td>
                      <td className="text-right">{formatMoney(item.total_amount)}</td>
                      <td>{formatTimestamp(item.createdAt)}</td>
                      <td className="text-right">
                        <div className="order-dashboard-einvoice-row-actions">
                          {canIssue && (
                            <Button
                              color="primary"
                              outline
                              size="xs"
                              title="Phát hành"
                              onClick={() => this.issueExistingEInvoice(rowInvoice)}
                            >
                              <i className="simple-icon-check" />
                            </Button>
                          )}
                          {canReadPdf && (
                            <Button
                              color="light"
                              size="xs"
                              title="Xem PDF"
                              onClick={() => this.viewEInvoicePdf(rowInvoice)}
                            >
                              <i className="simple-icon-doc" />
                            </Button>
                          )}
                          <Button
                            color="light"
                            size="xs"
                            title="Kiểm tra trạng thái"
                            onClick={() => this.checkEInvoiceStatus(rowInvoice)}
                          >
                            <i className="simple-icon-refresh" />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  renderEInvoiceTab = (invoice) => {
    const eInvoice = invoice?.e_invoice;
    const isEnabled = this.isEInvoiceEnabled();

    if (!isEnabled && !eInvoice) {
      return (
        <div className="order-dashboard-einvoice-empty">
          <i className="iconsminds-receipt-4" />
          <strong>Chưa cấu hình hóa đơn điện tử</strong>
          <p>Không thể phát hành HĐĐT cho hóa đơn này.</p>
        </div>
      );
    }

    if (!eInvoice) {
      return (
        <div className="order-dashboard-einvoice-empty">
          <i className="iconsminds-receipt-4" />
          <strong>Chưa có hóa đơn điện tử</strong>
          <p>
            {invoice.is_cancelled
              ? "Hóa đơn bán hàng đã hủy."
              : "Hóa đơn này chưa được phát hành HĐĐT."}
          </p>
          {this.renderEInvoiceActionButtons(invoice)}
        </div>
      );
    }

    const meta = this.getEInvoiceMeta(invoice);
    const feeOtherLabel = resolveFeeOtherLabel(
      this.props.intl.messages,
      invoice,
    );
    const invoiceTypeLabel =
      eInvoice.invoice_type === "adjustment" ? "Điều chỉnh" : "Gốc";

    return (
      <>
        <div className="order-dashboard-einvoice-status">
          <div>
            <span>Trạng thái HĐĐT</span>
            <strong>
              {eInvoice.invoice_no || "--"}
              {eInvoice.invoice_series ? ` / ${eInvoice.invoice_series}` : ""}
            </strong>
          </div>
          <Badge
            color={meta.color}
            pill
            className="order-dashboard-einvoice-badge"
            title={eInvoice.error_message || undefined}
          >
            {meta.label}
          </Badge>
        </div>

        {eInvoice.status === "error" && eInvoice.error_message && (
          <div className="alert alert-warning order-dashboard-einvoice-error">
            {eInvoice.error_message}
          </div>
        )}

        {this.renderEInvoiceActionButtons(invoice)}

        <Row>
          <Col lg="6" className="mb-3">
            <div className="order-dashboard-info-card">
              <h3>Thông tin HĐĐT</h3>
              <InfoRow label="Số hóa đơn" value={eInvoice.invoice_no || "--"} />
              <InfoRow label="Ký hiệu" value={eInvoice.invoice_series || "--"} />
              <InfoRow
                label="Nhà cung cấp"
                value={this.getEInvoiceProviderLabel(eInvoice.provider)}
                badge
              />
              <InfoRow label="Mã nhà cung cấp" value={eInvoice.provider_invoice_id || "--"} />
              <InfoRow label="Loại HĐĐT" value={invoiceTypeLabel} />
              <InfoRow
                label="Ngày hóa đơn"
                value={
                  eInvoice.invoice_date
                    ? moment(eInvoice.invoice_date).format("DD/MM/YYYY")
                    : "--"
                }
              />
              <InfoRow label="Ngày tạo" value={formatTimestamp(eInvoice.createdAt)} />
              <InfoRow label="Ngày phát hành" value={formatTimestamp(eInvoice.issued_at)} />
              <InfoRow label="Ngày gửi email" value={formatTimestamp(eInvoice.sent_email_at)} />
              {eInvoice.cancelled_at && (
                <InfoRow label="Ngày hủy" value={formatTimestamp(eInvoice.cancelled_at)} danger />
              )}
              <InfoRow label="Số bản ghi HĐĐT" value={invoice.e_invoice_count || 1} />
            </div>
          </Col>
          <Col lg="6" className="mb-3">
            <div className="order-dashboard-info-card">
              <h3>Người mua</h3>
              <InfoRow label="Tên" value={eInvoice.customer_name || "Khách lẻ"} />
              <InfoRow label="Mã số thuế" value={eInvoice.customer_tax_id || "--"} />
              <InfoRow label="Điện thoại" value={eInvoice.customer_phone || "--"} />
              <InfoRow label="Email" value={eInvoice.customer_email || "--"} />
              <InfoRow label="Địa chỉ" value={eInvoice.customer_address || "--"} />
            </div>
          </Col>
        </Row>

        <Row>
          <Col lg="6" className="mb-3">
            <div className="order-dashboard-payment-card">
              <h3>Giá trị HĐĐT</h3>
              <PaymentRow label="Tiền hàng" value={eInvoice.subtotal} />
              <PaymentRow label="Chiết khấu" value={eInvoice.discount_amount} />
              <PaymentRow label="Hình thức TT" value={eInvoice.payment_method || "--"} text />
              <PaymentRow
                label={`VAT (${eInvoice.vat_rate || 0}%)`}
                value={eInvoice.vat_amount}
              />
              <PaymentRow label="Thuế" value={eInvoice.tax_fee_amount} />
              <PaymentRow
                label={feeOtherLabel}
                value={eInvoice.fee_other_amount}
              />
              <PaymentRow label="Tổng HĐĐT" value={eInvoice.total_amount} strong />
            </div>
          </Col>
          <Col lg="6" className="mb-3">
            <div className="order-dashboard-note-card">
              <h3>Ghi chú HĐĐT</h3>
              <p>{eInvoice.note || "Không có ghi chú"}</p>
            </div>
          </Col>
        </Row>

        {this.renderEInvoiceAdjustments()}
      </>
    );
  };

  renderHistoryTab = (invoice) => {
    const events = Array.isArray(invoice.history) && invoice.history.length
      ? invoice.history
      : [
          {
            title: "Tạo hóa đơn",
            time: formatDateTime(invoice.date, invoice.time),
            tone: "primary",
          },
          {
            title: invoice.has_debt ? "Ghi nhận công nợ" : "Thanh toán",
            time: invoice.has_debt
              ? formatMoney(invoice.totals?.debt)
              : formatMoney(invoice.totals?.paid),
            tone: invoice.has_debt ? "warning" : "success",
          },
          ...(invoice.has_debt && Number(invoice.totals?.paid || 0) > 0
            ? [
                {
                  title: "Đã trả một phần công nợ",
                  time: formatMoney(invoice.totals?.paid),
                  tone: "success",
                },
              ]
            : []),
          ...(invoice.is_cancelled
            ? [
                {
                  title: "Hóa đơn đã hủy",
                  time: moment(invoice.updated_at).format("DD/MM/YYYY HH:mm"),
                  tone: "danger",
                },
              ]
            : []),
        ];

    return (
      <div className="order-dashboard-history">
        {events.map((event, index) => (
          <div className={`order-dashboard-history-item is-${event.tone}`} key={index}>
            <span />
            <div>
              <strong>{event.title}</strong>
              <p>{event.time}</p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  renderPreviewTab = (invoice) => {
    return (
      <ComponentToPrintWrapper
        orders_id={invoice.orders_id || []}
        onRefresh={this.dataListRender}
        dashboardMode={true}
      />
    );
  };

  renderDebtModal = () => {
    const {
      debtModalOpen,
      debtInvoice,
      debtAmount,
      debtCustomerName,
      debtCustomerPhone,
      debtCustomerAddress,
      debtSuggestions,
      isLoadingDebtCustomer,
      isSubmittingDebt,
    } = this.state;
    const invoiceTotal = Number(debtInvoice?.totals?.total || 0);
    const amountNumber = parseMoneyInput(debtAmount);

    return (
      <Modal
        isOpen={debtModalOpen}
        toggle={this.closeDebtModal}
        className="order-dashboard-repay-modal"
      >
        <ModalHeader toggle={this.closeDebtModal}>Ghi nhận công nợ</ModalHeader>
        <ModalBody>
          <div className="order-dashboard-repay-summary">
            <div>
              <span>Hóa đơn</span>
              <strong>#{debtInvoice?.code || "--"}</strong>
            </div>
            <div>
              <span>Tổng giá trị hóa đơn</span>
              <strong>{formatMoney(invoiceTotal)}</strong>
            </div>
          </div>

          <FormGroup>
            <Label>Số tiền chuyển sang nợ</Label>
            <Input
              value={debtAmount}
              onChange={this.onChangeDebtAmount}
              placeholder="Nhập số tiền ghi nợ"
            />
            <div className="order-dashboard-repay-hints">
              <Button
                color="light"
                size="sm"
                onClick={() => this.setState({ debtAmount: AddCommaNumber(Math.round(invoiceTotal)) })}
              >
                Ghi toàn bộ
              </Button>
              <span>
                Còn lại sau ghi nợ: {formatMoney(Math.max(0, invoiceTotal - amountNumber))}
              </span>
            </div>
          </FormGroup>

          <FormGroup className="position-relative">
            <Label>Số điện thoại khách hàng</Label>
            <Input
              value={debtCustomerPhone}
              onChange={(event) => this.onChangeDebtCustomerField("debtCustomerPhone", event)}
              placeholder="Nhập số điện thoại để tìm khách hàng"
              autoComplete="off"
            />
            {isLoadingDebtCustomer && (
              <span
                className="spinner-border spinner-border-sm position-absolute"
                style={{ right: "10px", top: "39px" }}
                role="status"
                aria-hidden="true"
              />
            )}
            {debtSuggestions.length > 0 && (
              <div
                className="position-absolute w-100 bg-white border rounded shadow-sm"
                style={{ zIndex: 1060, maxHeight: "200px", overflowY: "auto" }}
              >
                {debtSuggestions.map((customer) => (
                  <button
                    type="button"
                    key={customer.id}
                    className="btn btn-link text-left text-body w-100 border-bottom rounded-0 p-2"
                    onClick={() => this.selectDebtCustomer(customer)}
                  >
                    <strong>{customer.name || "Khách hàng"}</strong>
                    {customer.phone ? ` - ${customer.phone}` : ""}
                    {customer.address ? ` (${customer.address})` : ""}
                  </button>
                ))}
              </div>
            )}
          </FormGroup>

          <FormGroup>
            <Label>Tên khách hàng</Label>
            <Input
              value={debtCustomerName}
              onChange={(event) => this.onChangeDebtCustomerField("debtCustomerName", event)}
              placeholder="Nhập tên khách hàng"
            />
          </FormGroup>
          <FormGroup>
            <Label>Địa chỉ</Label>
            <Input
              value={debtCustomerAddress}
              onChange={(event) => this.onChangeDebtCustomerField("debtCustomerAddress", event)}
              placeholder="Địa chỉ khách hàng"
            />
          </FormGroup>

          <div className="order-dashboard-repay-actions">
            <Button color="light" onClick={this.closeDebtModal} disabled={isSubmittingDebt}>
              Hủy
            </Button>
            <Button
              color="success"
              onClick={this.submitDebt}
              disabled={
                isSubmittingDebt ||
                amountNumber <= 0 ||
                amountNumber > invoiceTotal ||
                (!debtCustomerName.trim() && !debtCustomerPhone.trim())
              }
            >
              {isSubmittingDebt ? "Đang xử lý..." : "Xác nhận ghi nợ"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    );
  };

  renderRepayModal = () => {
    const {
      repayModalOpen,
      repayInvoice,
      repayAmount,
      repayPaymentMethod,
      repayScope,
      isSubmittingRepay,
    } = this.state;
    const invoiceDebtAmount = Number(repayInvoice?.totals?.debt || 0);
    const customerDebtAmount = this.getCustomerDebt(repayInvoice);
    const debtAmount = this.getRepayDebtAmount(repayInvoice, repayScope);
    const amountNumber = parseMoneyInput(repayAmount);

    return (
      <Modal
        isOpen={repayModalOpen}
        toggle={this.closeRepayModal}
        className="order-dashboard-repay-modal"
      >
        <ModalHeader toggle={this.closeRepayModal}>Trả nợ hóa đơn</ModalHeader>
        <ModalBody>
          <div className="order-dashboard-repay-summary">
            <div>
              <span>Hóa đơn</span>
              <strong>#{repayInvoice?.code || "--"}</strong>
            </div>
            <div>
              <span>Khách hàng</span>
              <strong>
                {repayInvoice?.customer?.name || "Khách lẻ"}
                {repayInvoice?.customer?.phone ? ` - ${repayInvoice.customer.phone}` : ""}
              </strong>
            </div>
            <div>
              <span>Công nợ đơn này</span>
              <strong className="text-danger">{formatMoney(invoiceDebtAmount)}</strong>
            </div>
            <div>
              <span>Tổng công nợ</span>
              <strong className="text-danger">{formatMoney(customerDebtAmount)}</strong>
            </div>
          </div>

          <div className="form-group">
            <label>Phạm vi trả nợ</label>
            <div className="order-dashboard-repay-scope">
              <CustomInput
                type="radio"
                id="order-dashboard-repay-scope-invoice"
                name="order-dashboard-repay-scope"
                value="invoice"
                label="Đơn này"
                checked={repayScope === "invoice"}
                disabled={invoiceDebtAmount <= 0}
                onChange={this.onChangeRepayScope}
              />
              <CustomInput
                type="radio"
                id="order-dashboard-repay-scope-customer"
                name="order-dashboard-repay-scope"
                value="customer"
                label="Tổng công nợ"
                checked={repayScope === "customer"}
                disabled={customerDebtAmount <= 0}
                onChange={this.onChangeRepayScope}
              />
            </div>
          </div>

          <div className="form-group">
            <label>Số tiền trả</label>
            <Input
              value={repayAmount}
              onChange={this.onChangeRepayAmount}
              placeholder="Nhập số tiền trả"
            />
            <div className="order-dashboard-repay-hints">
              <Button
                color="light"
                size="sm"
                onClick={() =>
                  this.setState({
                    repayAmount: AddCommaNumber(Math.round(debtAmount)),
                  })
                }
              >
                Tất toán
              </Button>
              <span>
                Còn lại sau trả: {formatMoney(Math.max(0, debtAmount - amountNumber))}
              </span>
            </div>
          </div>

          <div className="form-group">
            <label>Phương thức thanh toán</label>
            <Input
              type="select"
              value={repayPaymentMethod}
              onChange={(e) => this.setState({ repayPaymentMethod: e.target.value })}
            >
              <option value="cash">Tiền mặt</option>
              <option value="transfer">Chuyển khoản</option>
              <option value="card">Thẻ</option>
            </Input>
          </div>

          <div className="order-dashboard-repay-actions">
            <Button color="light" onClick={this.closeRepayModal} disabled={isSubmittingRepay}>
              Hủy
            </Button>
            <Button
              color="success"
              onClick={this.submitRepayDebt}
              disabled={isSubmittingRepay || amountNumber <= 0 || amountNumber > debtAmount}
            >
              {isSubmittingRepay ? "Đang xử lý..." : "Xác nhận trả nợ"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    );
  };

  renderEInvoiceIssueModal = () => {
    if (!this.isEInvoiceEnabled()) return null;
    const {
      eInvoiceIssueModalOpen,
      eInvoiceMode,
      eInvoiceInvoice,
      eInvoiceCustomerName,
      eInvoiceCustomerTaxId,
      eInvoiceCustomerAddress,
      eInvoiceCustomerEmail,
      eInvoiceCustomerPhone,
      eInvoiceVatRate,
      eInvoicePaymentMethod,
      eInvoiceNote,
      eInvoiceIssueOfficial,
      isSubmittingEInvoice,
    } = this.state;
    const isEdit = eInvoiceMode === "edit";
    const feeOtherLabel = resolveFeeOtherLabel(
      this.props.intl.messages,
      eInvoiceInvoice,
    );

    return (
      <Modal
        isOpen={eInvoiceIssueModalOpen}
        toggle={this.closeEInvoiceIssueModal}
        size="lg"
        className="order-dashboard-einvoice-issue-modal"
      >
        <ModalHeader toggle={this.closeEInvoiceIssueModal}>
          {isEdit ? "Sửa thông tin hóa đơn điện tử" : "Xuất hóa đơn điện tử"}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Tên đơn vị / Người mua</Label>
                <Input
                  value={eInvoiceCustomerName}
                  onChange={(e) => this.setState({ eInvoiceCustomerName: e.target.value })}
                  placeholder="Tên công ty hoặc khách hàng"
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Mã số thuế</Label>
                <Input
                  value={eInvoiceCustomerTaxId}
                  onChange={(e) => this.setState({ eInvoiceCustomerTaxId: e.target.value })}
                  placeholder="Mã số thuế"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Số điện thoại</Label>
                <Input
                  value={eInvoiceCustomerPhone}
                  onChange={(e) => this.setState({ eInvoiceCustomerPhone: e.target.value })}
                  placeholder="Số điện thoại nhận hóa đơn"
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Email</Label>
                <Input
                  value={eInvoiceCustomerEmail}
                  onChange={(e) => this.setState({ eInvoiceCustomerEmail: e.target.value })}
                  placeholder="email@company.com"
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label>Địa chỉ</Label>
            <Input
              type="textarea"
              rows="2"
              value={eInvoiceCustomerAddress}
              onChange={(e) => this.setState({ eInvoiceCustomerAddress: e.target.value })}
              placeholder="Địa chỉ người mua"
            />
          </FormGroup>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Thuế VAT (%)</Label>
                <Input
                  type="number"
                  value={eInvoiceVatRate}
                  onChange={(e) => this.setState({ eInvoiceVatRate: e.target.value })}
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Hình thức thanh toán</Label>
                <Input
                  value={eInvoicePaymentMethod}
                  onChange={(e) => this.setState({ eInvoicePaymentMethod: e.target.value })}
                  placeholder="TM/CK"
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label>Ghi chú</Label>
            <Input
              type="textarea"
              rows="2"
              value={eInvoiceNote}
              onChange={(e) => this.setState({ eInvoiceNote: e.target.value })}
              placeholder={`Đơn hàng ${eInvoiceInvoice?.code || ""}`}
            />
          </FormGroup>
          <FormGroup>
            <Label>Trạng thái sau khi lưu</Label>
            <div className="order-dashboard-repay-scope">
              <CustomInput
                type="radio"
                id="order-dashboard-einvoice-issue-official"
                name="order-dashboard-einvoice-issue-mode"
                label="Phát hành chính thức"
                checked={eInvoiceIssueOfficial}
                onChange={() => this.setState({ eInvoiceIssueOfficial: true })}
              />
              <CustomInput
                type="radio"
                id="order-dashboard-einvoice-issue-draft"
                name="order-dashboard-einvoice-issue-mode"
                label="Lưu nháp"
                checked={!eInvoiceIssueOfficial}
                onChange={() => this.setState({ eInvoiceIssueOfficial: false })}
              />
            </div>
          </FormGroup>
          <div className="order-dashboard-repay-summary">
            <div>
              <span>Hóa đơn</span>
              <strong>#{eInvoiceInvoice?.code || "--"}</strong>
            </div>
            <div>
              <span>Tạm tính</span>
              <strong>{formatMoney(eInvoiceInvoice?.totals?.subtotal)}</strong>
            </div>
            <div>
              <span>Chiết khấu</span>
              <strong>{formatMoney(eInvoiceInvoice?.totals?.discount)}</strong>
            </div>
            <div>
              <span>Thuế</span>
              <strong>{formatMoney(eInvoiceInvoice?.totals?.tax_fee)}</strong>
            </div>
            <div>
              <span>{feeOtherLabel}</span>
              <strong>{formatMoney(eInvoiceInvoice?.totals?.fee_other)}</strong>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={this.closeEInvoiceIssueModal} disabled={isSubmittingEInvoice}>
            Hủy
          </Button>
          <Button color="primary" onClick={this.submitEInvoice} disabled={isSubmittingEInvoice}>
            {isSubmittingEInvoice ? "Đang xử lý..." : eInvoiceIssueOfficial ? "Phát hành" : "Lưu nháp"}
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  renderEInvoiceAdjustmentModal = () => {
    const {
      eInvoiceAdjustmentModalOpen,
      eInvoiceAdjustmentMode,
      eInvoiceAdjustmentInvoice,
      eInvoiceAdjustmentItems,
      eInvoiceAdjustmentDiscount,
      eInvoiceAdjustmentTaxFee,
      eInvoiceAdjustmentFeeOther,
      eInvoiceAdjustmentVatRate,
      eInvoiceAdjustmentReason,
      eInvoiceAdjustmentIssueOfficial,
      eInvoiceAdjustmentPreview,
      eInvoiceAdjustmentProductSearch,
      eInvoiceAdjustmentSelectedProductKey,
      isLoadingEInvoiceAdjustmentProducts,
      isPreviewingEInvoiceAdjustment,
      isSubmittingEInvoiceAdjustment,
    } = this.state;
    const isBillAdjustment = eInvoiceAdjustmentMode === "bill";
    if (!isBillAdjustment && !this.isEInvoiceEnabled()) return null;
    const canIssueOfficial = this.supportsEInvoiceAdjustment();
    const willIssueOfficial =
      !isBillAdjustment && eInvoiceAdjustmentIssueOfficial && canIssueOfficial;
    const provider = this.getCurrentEInvoiceProvider();
    const productRows = this.getEInvoiceAdjustmentProductRows();
    const targetTotals =
      eInvoiceAdjustmentPreview?.target?.totals ||
      this.getEInvoiceAdjustmentTargetTotals();
    const deltaTotals = eInvoiceAdjustmentPreview?.delta?.totals || {};
    const previewErrors = eInvoiceAdjustmentPreview?.errors || [];
    const feeOtherLabel = resolveFeeOtherLabel(
      this.props.intl.messages,
      eInvoiceAdjustmentInvoice,
    );

    return (
      <Modal
        isOpen={eInvoiceAdjustmentModalOpen}
        toggle={this.closeEInvoiceAdjustmentModal}
        size="xl"
        className="order-dashboard-einvoice-adjustment-modal"
      >
        <ModalHeader toggle={this.closeEInvoiceAdjustmentModal}>
          {isBillAdjustment ? "Điều chỉnh hóa đơn bán hàng" : "Điều chỉnh hóa đơn điện tử"}
        </ModalHeader>
        <ModalBody>
          <div className="order-dashboard-repay-summary mb-3">
            <div>
              <span>Hóa đơn</span>
              <strong>#{eInvoiceAdjustmentInvoice?.code || "--"}</strong>
            </div>
            {isBillAdjustment ? (
              <div>
                <span>Loại điều chỉnh</span>
                <strong>Hóa đơn bán hàng</strong>
              </div>
            ) : (
              <>
                <div>
                  <span>Số HĐĐT</span>
                  <strong>{eInvoiceAdjustmentInvoice?.e_invoice?.invoice_no || "--"}</strong>
                </div>
                <div>
                  <span>Provider</span>
                  <strong>{provider?.label || provider?.name || "--"}</strong>
                </div>
              </>
            )}
          </div>

          {isBillAdjustment && eInvoiceAdjustmentInvoice?.e_invoice && (
            <div className="alert alert-info py-2">
              Hóa đơn này đã có HĐĐT. Sau khi điều chỉnh hóa đơn bán hàng, bạn có thể lập HĐĐT điều chỉnh riêng nếu cần.
            </div>
          )}

          {!isBillAdjustment && !canIssueOfficial && (
            <div className="alert alert-warning py-2">
              Provider hiện tại chỉ cho lưu nháp hóa đơn điều chỉnh.
            </div>
          )}

          <Row className="align-items-end mb-3">
            <Col md="4">
              <FormGroup className="mb-md-0">
                <Label>Tìm sản phẩm</Label>
                <Input
                  value={eInvoiceAdjustmentProductSearch}
                  onChange={(e) =>
                    this.scheduleEInvoiceAdjustmentProductSearch(e.target.value)
                  }
                  placeholder="Tên, SKU, mã vạch"
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup className="mb-md-0">
                <Label>Sản phẩm thêm</Label>
                <Input
                  type="select"
                  value={eInvoiceAdjustmentSelectedProductKey}
                  disabled={isLoadingEInvoiceAdjustmentProducts || productRows.length === 0}
                  onChange={(e) =>
                    this.setState({
                      eInvoiceAdjustmentSelectedProductKey: e.target.value,
                    })
                  }
                >
                  {productRows.length === 0 ? (
                    <option value="">
                      {isLoadingEInvoiceAdjustmentProducts
                        ? "Đang tải..."
                        : "Không có sản phẩm"}
                    </option>
                  ) : (
                    productRows.map((row) => (
                      <option key={row.key} value={row.key}>
                        {row.label} - {formatMoney(this.getProductDisplayPrice(row.product, row.variant))}
                      </option>
                    ))
                  )}
                </Input>
              </FormGroup>
            </Col>
            <Col md="2">
              <Button
                color="primary"
                outline
                block
                onClick={this.addEInvoiceAdjustmentProduct}
                disabled={isLoadingEInvoiceAdjustmentProducts || productRows.length === 0}
              >
                <i className="simple-icon-plus mr-2" />
                Thêm
              </Button>
            </Col>
          </Row>

          <div className="table-responsive">
            <table className="table table-sm table-striped mb-3">
              <thead>
                <tr>
                  <th>Sản phẩm</th>
                  <th className="text-right">SL gốc</th>
                  <th className="text-right">SL mới</th>
                  <th className="text-right">Đơn giá</th>
                  <th className="text-right" />
                </tr>
              </thead>
              <tbody>
                {eInvoiceAdjustmentItems.map((item, index) => (
                  <tr key={`${item.item_code || item.item_name}-${index}`}>
                    <td>{item.item_name}</td>
                    <td className="text-right">{item.source_quantity}</td>
                    <td className="text-right" style={{ width: 140 }}>
                      <Input
                        type="number"
                        min="0"
                        value={item.quantity}
                        onChange={(e) =>
                          this.updateEInvoiceAdjustmentItem(index, "quantity", e.target.value)
                        }
                      />
                    </td>
                    <td className="text-right" style={{ width: 180 }}>
                      <Input
                        type="number"
                        min="0"
                        value={item.unit_price}
                        onChange={(e) =>
                          this.updateEInvoiceAdjustmentItem(index, "unit_price", e.target.value)
                        }
                      />
                    </td>
                    <td className="text-right" style={{ width: 60 }}>
                      <Button
                        color="danger"
                        outline
                        size="sm"
                        onClick={() => this.removeEInvoiceAdjustmentItem(index)}
                        title="Xóa dòng"
                        aria-label="Xóa dòng"
                      >
                        <i className="simple-icon-trash" />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <Row>
            <Col md="3">
              <FormGroup>
                <Label>Chiết khấu</Label>
                <Input
                  type="number"
                  min="0"
                  value={eInvoiceAdjustmentDiscount}
                  onChange={(e) =>
                    this.updateEInvoiceAdjustmentField(
                      "eInvoiceAdjustmentDiscount",
                      e.target.value,
                    )
                  }
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label>Thuế</Label>
                <Input
                  type="number"
                  min="0"
                  value={eInvoiceAdjustmentTaxFee}
                  onChange={(e) =>
                    this.updateEInvoiceAdjustmentField(
                      "eInvoiceAdjustmentTaxFee",
                      e.target.value,
                    )
                  }
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label>{feeOtherLabel}</Label>
                <Input
                  type="number"
                  min="0"
                  value={eInvoiceAdjustmentFeeOther}
                  onChange={(e) =>
                    this.updateEInvoiceAdjustmentField(
                      "eInvoiceAdjustmentFeeOther",
                      e.target.value,
                    )
                  }
                />
              </FormGroup>
            </Col>
            {!isBillAdjustment && (
              <Col md="3">
                <FormGroup>
                  <Label>VAT (%)</Label>
                  <Input
                    type="number"
                    value={eInvoiceAdjustmentVatRate}
                    onChange={(e) =>
                      this.updateEInvoiceAdjustmentField(
                        "eInvoiceAdjustmentVatRate",
                        e.target.value,
                      )
                    }
                  />
                </FormGroup>
              </Col>
            )}
          </Row>

          <FormGroup>
            <Label>Lý do điều chỉnh</Label>
            <Input
              type="textarea"
              rows="2"
              value={eInvoiceAdjustmentReason}
              onChange={(e) => this.setState({ eInvoiceAdjustmentReason: e.target.value })}
              placeholder="Nhập lý do"
            />
          </FormGroup>

          {!isBillAdjustment && (
            <FormGroup>
              <Label>Trạng thái sau khi lưu</Label>
              <div className="order-dashboard-repay-scope">
                <CustomInput
                  type="radio"
                  id="order-dashboard-einvoice-adjustment-official"
                  name="order-dashboard-einvoice-adjustment-mode"
                  label="Phát hành chính thức"
                  checked={willIssueOfficial}
                  disabled={!canIssueOfficial}
                  onChange={() => this.setState({ eInvoiceAdjustmentIssueOfficial: true })}
                />
                <CustomInput
                  type="radio"
                  id="order-dashboard-einvoice-adjustment-draft"
                  name="order-dashboard-einvoice-adjustment-mode"
                  label="Lưu nháp"
                  checked={!willIssueOfficial}
                  onChange={() => this.setState({ eInvoiceAdjustmentIssueOfficial: false })}
                />
              </div>
            </FormGroup>
          )}

          <div className="order-dashboard-repay-summary mb-3">
            <div>
              <span>Tiền hàng mới</span>
              <strong>{formatMoney(targetTotals.subtotal || 0)}</strong>
            </div>
            <div>
              <span>Chiết khấu mới</span>
              <strong>{formatMoney(targetTotals.discount || 0)}</strong>
            </div>
            <div>
              <span>Thuế mới</span>
              <strong>{formatMoney(targetTotals.tax_fee || 0)}</strong>
            </div>
            <div>
              <span>{feeOtherLabel} mới</span>
              <strong>{formatMoney(targetTotals.fee_other || 0)}</strong>
            </div>
            <div>
              <span>Thành tiền mới</span>
              <strong>{formatMoney(targetTotals.total || 0)}</strong>
            </div>
          </div>

          <div className="order-dashboard-repay-summary">
            <div>
              <span>Chênh tiền hàng</span>
              <strong>{formatMoney(deltaTotals.subtotal || 0)}</strong>
            </div>
            <div>
              <span>Chênh chiết khấu</span>
              <strong>{formatMoney(deltaTotals.discount || 0)}</strong>
            </div>
            <div>
              <span>Chênh thuế</span>
              <strong>{formatMoney(deltaTotals.tax_fee || 0)}</strong>
            </div>
            <div>
              <span>Chênh {feeOtherLabel}</span>
              <strong>{formatMoney(deltaTotals.fee_other || 0)}</strong>
            </div>
            <div>
              <span>Tổng chênh lệch</span>
              <strong>{formatMoney(deltaTotals.total || 0)}</strong>
            </div>
          </div>

          {previewErrors.length > 0 && (
            <div className="alert alert-light border mt-3 py-2">
              {previewErrors.join(". ")}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="light"
            onClick={this.refreshEInvoiceAdjustmentPreview}
            disabled={isPreviewingEInvoiceAdjustment || isSubmittingEInvoiceAdjustment}
          >
            {isPreviewingEInvoiceAdjustment ? "Đang tính..." : "Cập nhật chênh lệch"}
          </Button>
          <Button
            color="light"
            onClick={this.closeEInvoiceAdjustmentModal}
            disabled={isSubmittingEInvoiceAdjustment}
          >
            Hủy
          </Button>
          <Button
            color="primary"
            onClick={this.submitEInvoiceAdjustment}
            disabled={isSubmittingEInvoiceAdjustment}
          >
            {isSubmittingEInvoiceAdjustment
              ? "Đang xử lý..."
              : isBillAdjustment
                ? "Lưu điều chỉnh"
                : willIssueOfficial
                ? "Phát hành"
                : "Lưu nháp"}
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  render() {
    const { is_loading_data, eInvoiceModalOpen, isDetailModalOpen } = this.state;

    if (!this.canViewOrderDashboard()) {
      return (
        <Card className="text-muted mh-40vh h-100">
          <CardBody className="d-flex justify-content-center align-items-center">
            <IntlMessages id="invoice.no-permission" />
          </CardBody>
        </Card>
      );
    }

    return (
      <div className="order-dashboard disable-text-selection">
        {this.renderSummaryCards()}
        {this.renderToolbar()}
        {this.renderStatusFilters()}
        {is_loading_data ? (
          <div className="loading" />
        ) : (
          <Row className="order-dashboard-main">
            <Col xs="12" xl="6" className="mb-3 pl-0 pr-2">
              {this.renderInvoiceList()}
            </Col>
            <Col xs="12" xl="6" className="mb-3 pl-2 pr-0">
              {this.renderDetailPanel()}
            </Col>
          </Row>
        )}
        <Modal
          isOpen={eInvoiceModalOpen}
          toggle={() => this.setState({ eInvoiceModalOpen: false })}
          size="xl"
          className="order-dashboard-einvoice-modal"
        >
          <ModalHeader toggle={() => this.setState({ eInvoiceModalOpen: false })}>
            Hóa đơn điện tử
          </ModalHeader>
          <ModalBody>
            <EInvoiceList />
          </ModalBody>
        </Modal>
        {this.renderEInvoiceIssueModal()}
        {this.renderEInvoiceAdjustmentModal()}
        {this.renderDebtModal()}
        {this.renderRepayModal()}

        <Modal
          isOpen={isDetailModalOpen}
          toggle={this.closeDetailModal}
          size="lg"
          className="order-dashboard-detail-modal"
        >
          <ModalHeader toggle={this.closeDetailModal}>
            Chi tiết hóa đơn
          </ModalHeader>
          <ModalBody className="p-0">
            {this.renderDetailPanel()}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const InfoRow = ({ label, value, badge, danger }) => (
  <div className="order-dashboard-info-row">
    <span>{label}</span>
    {badge ? (
      <Badge color="primary" pill className="order-dashboard-info-badge">
        {value}
      </Badge>
    ) : (
      <strong className={classNames({ "text-danger": danger })}>{value}</strong>
    )}
  </div>
);

const PaymentRow = ({ label, value, strong, success, text }) => (
  <div
    className={classNames("order-dashboard-payment-row", {
      strong,
      success,
    })}
  >
    <span>{label}</span>
    <strong>{text ? value : formatMoney(value)}</strong>
  </div>
);

const mapStateToProps = ({ menu, searchInput }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  const { keyword: searchKeyword } = searchInput;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
    searchKeyword,
  };
};

export default connect(mapStateToProps, {
  setContainerClassnames,
  clickOnMobileMenu,
  setSearchContext,
})(injectIntl(ContentComponent));
